webpackJsonp([0],{

/***/ "+HnR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+wi3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlbumPhoto_vue__ = __webpack_require__("5TV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7adf33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlbumPhoto_vue__ = __webpack_require__("fZNE");
function injectStyle (ssrContext) {
  __webpack_require__("bk6z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlbumPhoto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7adf33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlbumPhoto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+xmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_SilentboxGallery_vue__ = __webpack_require__("WU/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_pagination_Pagination_vue__ = __webpack_require__("LeuH");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['album', 'page'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        // console.log('ALBUM: ', this.album);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'gallery',
            endpointSearch: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'searchGallery',
            photoUrl: __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */],
            query: '',
            errorClass: '',
            size: '/1960/',
            albumName: 'Galerija slik'
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_SilentboxGallery_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__["a" /* default */],
        'app-pagination': __WEBPACK_IMPORTED_MODULE_6__components_elements_pagination_Pagination_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['gallery', 'loading', 'error', 'title', 'paginate', 'pagination']), {
        imagePath: function imagePath() {
            // console.log('image path: ', PhotoUrl);
            return __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */] + this.gallery.album_id + this.size;
        },
        galleryPhotos: function galleryPhotos() {
            // console.log('gallery photos: ', this.gallery.photos);
            return this.gallery.photos;
        },
        galleryName: function galleryName() {
            if (typeof this.title !== 'undefined' || this.title !== '') {
                return this.capitalize(this.title);
            }
            if (typeof this.album !== 'undefined' || this.album !== '') {
                return this.capitalize(this.album);
            }
            return this.albumName;
        },
        componentEndpoint: function componentEndpoint() {
            // console.log('gallery endpoint: ', '/gallery/' + this.album);
            if (typeof this.album === 'undefined') {
                return '/galerija/p';
            }
            return '/galerija/album/' + this.album;
        },
        searchError: function searchError() {
            if (this.query !== '' && this.gallery.error && this.gallery.error !== '') {
                // console.log(' error for filters ');
                this.errorClass = '';
                return true;
            }
            this.errorClass = 'is-hidden';
            return false;
        }
    }),

    methods: {
        /**
         * get paginated results - for page > 1
         * paginate - navigation click
         */
        getResults: function getResults(page) {
            if (typeof page === 'undefined') {
                page = 2;
            }
            var endpoint = this.endpoint;
            if (typeof this.album !== 'undefined') {
                // console.log('getResults - gallery IF: ', this.album, this.page);
                endpoint = this.endpoint + '/' + this.album;
            } else {
                // page = this.page;
                // endpoint = this.endpoint + '/p/' + page;
                alert('we should not be here getResults - gallery: ELSE ' + this.page + endpoint);
            }
            var data = {
                endpoint: endpoint,
                page: page,
                type: 'gallery',
                album: this.album,
                photo: ''
            };
            // console.log('gallery getResults: ', endpoint, ' page: ', page, 'this.page: ', this.page, ' album: ', this.album);
            this.$store.dispatch('getPaginatedItems', data);
        },
        fetchAlbumPhotos: function fetchAlbumPhotos() {
            var endpoint = this.endpoint;

            var page = this.page;
            if (typeof this.page === 'undefined') {
                // console.log('PAGE undefined');
                page = 1;
            }

            var data = {
                endpoint: endpoint,
                page: page,
                type: 'gallery',
                album: ''
            };

            if (typeof this.album !== 'undefined') {
                // http://localhost:8090/galerija/album/ola/1

                endpoint = this.endpoint + '/' + this.album + '/' + page;

                data.endpoint = endpoint;
                data.album = this.album;
                // console.log('fetch gallery -  album: ', data, ' album: ', this.album, ' photo: ', this.photo);
            } else {
                // http://localhost:8090/galerija
                // endpoint = this.endpoint + '/p/' + page;
                // data.endpoint = endpoint;
                alert('should not be here !!!');
            }

            // console.log('PAGE undefined? ', data);
            this.$store.dispatch('fetchGallery', data);
        },
        clear: function clear() {
            this.query = '';
            this.$store.dispatch('clearNotification');
            this.$store.dispatch('clearError');
            this.fetchAlbumPhotos();
        },
        submitPrevent: function submitPrevent(event) {
            // console.log('prevent submit: ', event);
            event.stopPropagation();
            event.preventDefault();
            // return false;
        },


        /**
         * live search
         */
        itemFilter: function itemFilter() {
            var self = this;
            if (self.query === '') {
                // console.log('empty query, fetch all photos for album: ', this.album, ' page: ', this.page);
                // this.fetchPhoto();
                this.fetchAlbumPhotos();
            } else {
                var first = 'name';
                var second = 'description';
                var third = '';

                // if(this.link === '/photos/') {
                first = 'name';
                second = 'album_id';
                third = 'location_id';
                // }
                this.endpoint = this.endpointSearch;
                var data = {
                    field: [first, second],
                    value: self.query,
                    endpoint: this.endpoint
                };

                this.$store.dispatch('fetchGalleryFilter', data);
            }
        }
    },

    created: function created() {
        this.itemFilter();
    }
});

/***/ }),

/***/ "/Iqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Weather_vue__ = __webpack_require__("5+An");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c058540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Weather_vue__ = __webpack_require__("xRK2");
function injectStyle (ssrContext) {
  __webpack_require__("3bTY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Weather_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c058540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Weather_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Ulc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryPhoto_vue__ = __webpack_require__("xUqD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f815b170_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryPhoto_vue__ = __webpack_require__("KWRn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryPhoto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f815b170_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryPhoto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/vj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_FlexHeaderBar__ = __webpack_require__("FyGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_complex_CaGeneral__ = __webpack_require__("0Obv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_complex_CaFooter__ = __webpack_require__("RDwC");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'about'
        };
    },


    components: {
        'app-flex-header': __WEBPACK_IMPORTED_MODULE_2__components_layout_FlexHeaderBar__["a" /* default */],
        'app-action-call-general': __WEBPACK_IMPORTED_MODULE_3__components_complex_CaGeneral__["a" /* default */],
        'app-action-call-footer': __WEBPACK_IMPORTED_MODULE_4__components_complex_CaFooter__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['items', 'error', 'loading', 'title'])),

    methods: {
        fetchAbout: function fetchAbout() {
            this.$store.dispatch('fetchItems', this.endpoint);
        }
    },

    mounted: function mounted() {
        this.fetchAbout();
        // console.log('About - Component mounted.')
    }
});

/***/ }),

/***/ "0CA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pagination is-right",attrs:{"role":"navigation","aria-label":"pagination"}},[_c('ul',{staticClass:"pagination-list"},[(_vm.pagination.current_page > 1)?_c('li',[_c('a',{staticClass:"pagination-previous",attrs:{"aria-label":"First"},on:{"click":function($event){$event.preventDefault();_vm.onChange(1)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("««")])]),_vm._v(" "),_c('a',{staticClass:"pagination-previous",attrs:{"aria-label":"Previous"},on:{"click":function($event){$event.preventDefault();_vm.onChange(_vm.pagination.current_page - 1)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("«")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pagesNumber),function(page){return _c('li',{class:_vm.getClass(page)},[_c('a',{attrs:{"aria-label":"Next","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onChange(page)}}},[_vm._v(_vm._s(page))])])}),_vm._v(" "),(_vm.pagination.current_page < _vm.pagination.last_page)?_c('li',[_c('a',{staticClass:"pagination-next",on:{"click":function($event){$event.preventDefault();_vm.onChange(_vm.pagination.current_page + 1)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("»")])]),_vm._v(" "),_c('a',{staticClass:"pagination-next",on:{"click":function($event){$event.preventDefault();_vm.onChange(_vm.pagination.last_page)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("»»")])])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Obv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaGeneral_vue__ = __webpack_require__("3Tgn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4123bb3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaGeneral_vue__ = __webpack_require__("TfSf");
function injectStyle (ssrContext) {
  __webpack_require__("QFAX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4123bb3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaGeneral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4123bb3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaGeneral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1H2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-pagination',
    props: {
        offset: {
            type: Number,
            default: 4
        },
        endpoint: {
            type: String
        }
    },
    data: function data() {
        return {
            currentPage: '',
            href: ''
        };
    },


    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['items', 'paginate', 'pagination', 'error']), {
        pagesNumber: function pagesNumber() {
            // if only one page, hide pagination
            if (this.pagination.current_page === 1 && this.pagination.current_page === this.pagination.last_page) {
                return;
            }
            if (!this.pagination.to) {
                return [];
            }
            var from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            var to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            var pagesArray = [];
            for (from = 1; from <= to; from++) {
                pagesArray.push(from);
            }

            return pagesArray;
        }
    }),

    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['setPaginationCurrentPage']), {
        getClass: function getClass(item) {
            return this.pagination.current_page !== item ? 'pagination-link' : 'pagination-link is-current';
        },
        preventClick: function preventClick(event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }),
    mounted: function mounted() {
        // console.log('pagination - Component mounted.');
    }
});

/***/ }),

/***/ "1O7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBar_vue__ = __webpack_require__("M7uO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7506591c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBar_vue__ = __webpack_require__("7MIy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7506591c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1TnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__ = __webpack_require__("U0mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b38b0ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__ = __webpack_require__("pMPE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b38b0ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1b8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"silentbox-group"}},[_vm._t("default"),_vm._v(" "),_c('silentbox-overlay')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2a/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters_capitalize__ = __webpack_require__("T1tQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_uppercase__ = __webpack_require__("VHrM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_lowercase__ = __webpack_require__("W+dz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters_truncate__ = __webpack_require__("wqDD");





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    filters: {
        capitalize: __WEBPACK_IMPORTED_MODULE_0__filters_capitalize__["a" /* default */],
        uppercase: __WEBPACK_IMPORTED_MODULE_1__filters_uppercase__["a" /* default */],
        lowercase: __WEBPACK_IMPORTED_MODULE_2__filters_lowercase__["a" /* default */],
        truncate: __WEBPACK_IMPORTED_MODULE_3__filters_truncate__["a" /* default */]
    },
    methods: {
        lowerize: function lowerize(value) {
            return this.$options.filters.lowercase(value);
        },
        upperize: function upperize(value) {
            return this.$options.filters.uppercase(value);
        },
        stripTags: function stripTags(str) {
            if (str === null || str === '' || str === undefined) {
                return false;
            }
            str = str.toString();
            return str.replace(/<[^>]*>/g, '');
        },
        capitalize: function capitalize(value) {
            return this.$options.filters.capitalize(value);
        },
        truncate: function truncate(value, length) {
            value = this.stripTags(value);
            return this.$options.filters.truncate(value, length);
        }
    }
});

/***/ }),

/***/ "2aMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_gmaps_GoogleMaps_vue__ = __webpack_require__("ixP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_FlexHeaderBar__ = __webpack_require__("FyGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_weather_Weather__ = __webpack_require__("/Iqk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_form_ContactForm__ = __webpack_require__("LSlJ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'contact'
        };
    },


    components: {
        'app-google-map': __WEBPACK_IMPORTED_MODULE_2__components_elements_gmaps_GoogleMaps_vue__["a" /* default */],
        'app-weather': __WEBPACK_IMPORTED_MODULE_4__components_elements_weather_Weather__["a" /* default */],
        'app-flex-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_FlexHeaderBar__["a" /* default */],
        'app-contact-form': __WEBPACK_IMPORTED_MODULE_5__components_elements_form_ContactForm__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['items'])),

    methods: {
        fetchContact: function fetchContact() {
            this.$store.dispatch('fetchItems', this.endpoint);
        }
    },

    mounted: function mounted() {
        this.fetchContact();
        // console.log('Contact - Component mounted.')
    }
});

/***/ }),

/***/ "2dmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("bC5p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b407986_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("Gfxf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b407986_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Tgn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_weather_Weather__ = __webpack_require__("/Iqk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-action-call-general',
    props: ['quote', 'zeroPadding'],
    components: {
        'app-weather': __WEBPACK_IMPORTED_MODULE_0__elements_weather_Weather__["a" /* default */]
    },
    computed: {
        classObj: function classObj() {
            if (this.zeroPadding !== undefined) {
                return ' padding0';
            } else {
                return ' padding30';
            }
        }
    },
    data: function data() {
        return {
            //
        };
    }
});

/***/ }),

/***/ "3bTY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3gIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBar_vue__ = __webpack_require__("ksSj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270cdb80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBar_vue__ = __webpack_require__("wRHr");
function injectStyle (ssrContext) {
  __webpack_require__("wnLF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270cdb80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3gNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("uuel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53fe0ae2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("VGM0");
function injectStyle (ssrContext) {
  __webpack_require__("Lt18")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53fe0ae2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3l8e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4WGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("VatP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525d2f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("BDV2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525d2f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ewA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gallery-album"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),(_vm.gallery)?_c('div',[_c('h1',{staticClass:"title has-text-centered mtb-80 is-size-1"},[_c('span',{domProps:{"textContent":_vm._s(_vm.galleryName)}})]),_vm._v(" "),_c('div',{staticClass:"mtb-20 rel"},[_c('form',{attrs:{"id":"search","autocomplete":"off"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submitPrevent($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"input searchInput",attrs:{"id":"searchField","name":"query","placeholder":"Išči ..."},domProps:{"value":(_vm.query)},on:{"keyup":_vm.itemFilter,"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.query !=='')?_c('span',{staticClass:"is-icon",on:{"click":_vm.clear}},[_c('i',{staticClass:"close"},[_vm._v("X")])]):_vm._e()]),_vm._v(" "),(_vm.searchError)?_c('p',{staticClass:"has-text-danger has-text-right",class:_vm.errorClass},[_vm._v("Filter slike "+_vm._s(_vm.query)+": "+_vm._s(_vm._f("lowercase")(_vm.gallery.error))+" ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"breadcrumbs-parent",staticStyle:{"left":"20px","top":"50px","display":"flex"}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/galerija"}},[_vm._v("Galerija")])],1),_vm._v(" "),_c('li',{domProps:{"textContent":_vm._s(_vm.capitalize(_vm.album))}})])])]),_vm._v(" "),_c('app-pagination',{attrs:{"pagination":_vm.pagination,"endpoint":_vm.componentEndpoint,"offset":4},nativeOn:{"click":function($event){_vm.getResults(_vm.pagination.current_page)}}}),_vm._v(" "),_c('app-sb',{staticClass:"full-page",attrs:{"photos":_vm.gallery.photos.data,"albumId":"photo-gallery"}}),_vm._v(" "),_c('app-pagination',{attrs:{"endpoint":_vm.componentEndpoint,"pagination":_vm.pagination,"offset":4},nativeOn:{"click":function($event){_vm.getResults(_vm.pagination.current_page)}}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4iTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxOverlay',
    data: function data() {
        return {
            video: false
        };
    },

    computed: {
        getEmbedUrl: function getEmbedUrl() {
            return this.handleUrl(this.$parent.embedUrl);
        },
        isVisible: function isVisible() {
            if (this.$parent.overlayVisibility !== undefined && this.$parent.overlayVisibility !== false) {
                return true;
            }

            return false;
        }
    },
    methods: {
        moveToNextItem: function moveToNextItem() {
            this.$parent.nextItem();
        },
        moveToPreviousItem: function moveToPreviousItem() {
            this.$parent.prevItem();
        },
        closeSilentboxOverlay: function closeSilentboxOverlay() {
            this.$parent.$emit('closeSilentboxOverlay');
        },
        handleUrl: function handleUrl(url) {
            if (url.includes('youtube.com')) {
                this.video = true;

                var videoIdPosition = url.indexOf('v=') + 2;
                var videoId = url.substring(videoIdPosition);

                var videoUrl = 'https://www.youtube.com/embed/' + videoId;

                if (this.$parent.autoplay) {
                    videoUrl += '?autoplay=1';
                }

                return videoUrl;
            } else {
                this.video = false;

                return url;
            }
        }
    },
    beforeUpdate: function beforeUpdate() {
        var body = document.body;

        // add class only if overlay should be visible
        if (this.isVisible && !body.classList.contains('silentbox-is-opened')) {
            return body.classList.add('silentbox-is-opened');
        }

        // remove class only if overlay should be hidden
        if (!this.isVisible && body.classList.contains('silentbox-is-opened')) {
            return body.classList.remove('silentbox-is-opened');
        }
    }
});

/***/ }),

/***/ "5+An":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-weather',
    props: ['title', 'language'],

    data: function data() {

        return {
            //
        };
    },


    methods: {
        getLanguage: function getLanguage() {
            return this.language;
        }
    },

    mounted: function mounted() {
        // current instance
        // console.log('this is current weather', this.title, this.language)
        var appWeather = document.createElement('script');
        appWeather.setAttribute('src', 'https://oap.accuweather.com/launch.js');
        // document.getElementById('weather').appendChild(appWeather);
        document.head.appendChild(appWeather);
    }
});

/***/ }),

/***/ "552Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_StringsMixin__["a" /* default */]],
    // set props to T, pass the id instead of using this.$route.params.id
    props: ['id'],
    data: function data() {
        // console.log('ALBUM id: ', document.title, this.id);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'album/' + this.id,
            photoSize: '1280'
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_4__components_layout_HeaderBar_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_3__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_5__components_layout_BackButton_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['albumMain', 'loading', 'error', 'title']), {
        imagePath: function imagePath() {
            return AlbumsPhotoUrl + this.photoSize + '/';
        }
    }),

    methods: {
        pedigreePath: function pedigreePath(id, image, src) {
            if (src !== undefined && !src) {
                return __WEBPACK_IMPORTED_MODULE_0__env__["g" /* baseUrl */] + '/uploads/' + id + '/pedigree/960/' + image;
            }
            return __WEBPACK_IMPORTED_MODULE_0__env__["g" /* baseUrl */] + '/uploads/' + id + '/pedigree/1280/' + image;
        },
        fetchAlbum: function fetchAlbum() {
            // console.log('fetch album from album.vue');
            this.$store.dispatch('fetchAlbum', this.endpoint);
        }
    },

    created: function created() {
        // console.log('ALBUM - Component created.')
        this.fetchAlbum();
    }
});

/***/ }),

/***/ "5Ao0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5TV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_gmaps_GoogleMaps_vue__ = __webpack_require__("ixP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['photo', 'photoDetails'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        // console.log('photo: ', this.photo, this.photoDetails, this);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'photo/' + this.photo,
            photoSize: '1960',
            // photoSize: 'original',
            photoSmall: '300'
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__["a" /* default */],
        'app-google-map': __WEBPACK_IMPORTED_MODULE_5__components_elements_gmaps_GoogleMaps_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['albumPhoto', 'loading', 'error', 'title']), {
        imagePath: function imagePath() {
            return this.albumPhoto.photo.imagePath;
        },
        slug: function slug() {
            return __WEBPACK_IMPORTED_MODULE_0__env__["d" /* GalleryAlbumLink */] + this.albumPhoto.photo.album.slug;
        }
    }),

    methods: {
        fetchPhoto: function fetchPhoto() {
            // console.log('FETCH photo (album-photo): ', this.photo, this.endpoint, this.album, this.$router);
            var album = '';
            if (typeof this.album !== 'undefined') {
                album = this.album;
            }
            var data = {
                endpoint: this.endpoint,
                type: 'photo',
                photo: this.photo
                // album: !!this.album
            };
            console.log('PHOTO data: ', data);
            this.$store.dispatch('fetchPhoto', data);
        },
        getPhoto: function getPhoto(item) {
            return item.imagePath;
        }
    },

    created: function created() {
        this.fetchPhoto();
    }
});

/***/ }),

/***/ "5emR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlbumLocation_vue__ = __webpack_require__("jtOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b08b1878_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlbumLocation_vue__ = __webpack_require__("y9gd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlbumLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b08b1878_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlbumLocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5mWP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"has-text-right"},[_c('a',{staticClass:"button is-medium is-light is-outlined",class:_vm.classBtn,attrs:{"href":_vm.link}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7MIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"pull-left"},_vm._l((_vm.footerMenu),function(item){return _c('router-link',{key:item.title,attrs:{"tag":"span","to":item.link,"exact":""}},[_c('a',[_vm._v(" "+_vm._s(item.title)+" ")])])})),_vm._v(" "),_c('p',{staticClass:"pull-right"},[_vm._v("Izdelava: "),_c('a',{attrs:{"href":"tesispro.eu","target":"_blank"}},[_vm._v("©Tesis")]),_vm._v(" | Moje živalce | 2006- "+_vm._s(_vm.getYear))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7hk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxItem',
    props: {
        // Media source, it could be an image or a youtube video.
        'src': {
            type: String,
            required: true
        },
        // True if video should be autoplayed.
        'autoplay': {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        // Short description below image.
        'description': String,
        'position': {}
    },
    computed: {
        /**
         * Get embed URL.
         * @return {string|null}
         */
        embedUrl: function embedUrl() {
            if (this.src !== null) {
                return this.src;
            }

            return null;
        }
    },
    methods: {
        /**
         * Emit an event that overlay should be hidden.
         *
         * @return {void}
         */
        closeSilentBoxOverlay: function closeSilentBoxOverlay() {
            this.$parent.$emit('closeSilentboxOverlay');
        },

        /**
         * Emit an event that overlay should be opened.
         *
         * @return {void}
         */
        openSilentBoxOverlay: function openSilentBoxOverlay() {
            var _this = this;

            var itemIndex = this.$parent.items.list.findIndex(function (item) {
                return item.src === _this.src;
            });

            this.$parent.$emit('openSilentboxOverlay', {
                url: this.embedUrl,
                position: itemIndex,
                autoplay: this.autoplay,
                description: this.description
            });
        }
    },
    created: function created() {
        // Push items to the parent component.
        // TODO: do it in parent component
        this.$parent.items.list.push({
            src: this.src,
            autoplay: this.autoplay,
            desc: this.description,
            position: this.position
        });
    }
});

/***/ }),

/***/ "83hq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact-page"}},[_c('app-flex-header'),_vm._v(" "),(_vm.items.page)?_c('div',{staticClass:"columns has-text-centered p-centered-40"},[_c('div',{staticClass:"column is-one-half",attrs:{"id":"weather"}},[_c('div',{staticClass:"mt-80",domProps:{"innerHTML":_vm._s(_vm.items.page.description)}})]),_vm._v(" "),_c('div',{staticClass:"column is-one-half"},[_c('app-contact-form',{staticClass:"mtb-120"})],1)]):_vm._e(),_vm._v(" "),(_vm.items.post)?_c('div',{staticClass:"columns testi-container limegreen-panel"},[_c('div',{staticClass:"column is-one-third"},[_c('blockquote',{staticClass:"mt-100"},[_c('span',[_vm._v(_vm._s(_vm.items.quote.quote))]),_vm._v(" "),_c('cite',[_vm._v(_vm._s(_vm.items.quote.author))])])]),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_vm._m(0),_vm._v(" "),_c('app-weather',{attrs:{"language":"sl-si","title":"Vreme danes"}})],1),_vm._v(" "),_c('div',{staticClass:"column is-one-third post-content"},[_c('h3',{staticClass:"is-4"},[_c('a',{attrs:{"href":_vm.items.post.link}},[_vm._v(_vm._s(_vm.items.post.title))])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.items.post.content)}}),_vm._v(" "),_c('a',{staticClass:"general-link",attrs:{"href":"/blog"}},[_vm._v("Vsi članki")])])]):_vm._e(),_vm._v(" "),(_vm.items.page)?_c('section',{staticClass:"section full"},[_c('app-google-map',{attrs:{"mapName":"('contact')"}})],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"complex-line mt-80",attrs:{"title":"Vreme danes"}},[_c('span',{staticClass:"related weather"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8SjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StickyButton_vue__ = __webpack_require__("EvY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_form_ContactForm__ = __webpack_require__("LSlJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_vue__ = __webpack_require__("PEfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ModalMixin__ = __webpack_require__("N/At");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-mail-categories-stycky',
    props: ['items'],
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ModalMixin__["a" /* default */]],
    data: function data() {
        return {
            isOpen: false
        };
    },


    components: {
        'app-stycky': __WEBPACK_IMPORTED_MODULE_0__StickyButton_vue__["a" /* default */],
        'app-modal': __WEBPACK_IMPORTED_MODULE_2__Modal_vue__["a" /* default */],
        'app-contact-form': __WEBPACK_IMPORTED_MODULE_1__elements_form_ContactForm__["a" /* default */]
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),

/***/ "952d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getResponse)?_c('app-notification',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowing),expression:"isShowing"}],attrs:{"level":_vm.level,"message":_vm.message}}):_vm._e(),_vm._v(" "),(!_vm.isSent)?_c('div',[_c('form',{attrs:{"method":"POST","action":"/sendMail","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)},"keyup":_vm.close}},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input is-large",attrs:{"type":"text","placeholder":"Jaz sem*"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input is-large",attrs:{"type":"text","placeholder":"Moj e-dom*"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.place),expression:"place"}],staticClass:"input is-large",attrs:{"type":"text","placeholder":"Moj pravi dom (kraj)"},domProps:{"value":(_vm.place)},on:{"input":function($event){if($event.target.composing){ return; }_vm.place=$event.target.value}}}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-left has-icons-right"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.body),expression:"body"}],staticClass:"textarea is-large",attrs:{"placeholder":"In ti pišem ... *","rows":"3"},domProps:{"value":(_vm.body)},on:{"input":function($event){if($event.target.composing){ return; }_vm.body=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-info is-large is-block",class:_vm.classObj,on:{"click":_vm.onSubmit}},[_vm._v("Pošlji")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-home"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A8vF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AEdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"silentbox-item",attrs:{"src":_vm.src},on:{"click":_vm.openSilentBoxOverlay}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AiQ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BDV2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gallery"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),(_vm.gallery)?_c('div',[_c('h1',{staticClass:"title has-text-centered mtb-80 is-size-1"},[_vm._v("Galerija slik")]),_vm._v(" "),_c('div',{staticClass:"mtb-20"},[_c('form',{attrs:{"id":"search","autocomplete":"off"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submitPrevent($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"input searchInput",attrs:{"id":"searchField","name":"query","placeholder":"Išči ..."},domProps:{"value":(_vm.query)},on:{"keyup":_vm.itemFilter,"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.query !=='')?_c('span',{staticClass:"is-icon",on:{"click":_vm.clear}},[_c('i',{staticClass:"close"},[_vm._v("X")])]):_vm._e()]),_vm._v(" "),(_vm.searchError)?_c('p',{staticClass:"has-text-danger has-text-right",class:_vm.errorClass},[_vm._v("Filter slike "+_vm._s(_vm.query)+": "+_vm._s(_vm._f("lowercase")(_vm.gallery.error))+" ")]):_vm._e()]),_vm._v(" "),_c('app-pagination',{attrs:{"pagination":_vm.pagination,"endpoint":_vm.componentEndpoint,"offset":4},nativeOn:{"click":function($event){_vm.getResults(_vm.pagination.current_page)}}}),_vm._v(" "),_c('app-sb',{staticClass:"full-page",attrs:{"photos":_vm.gallery.photos.data,"albumId":"photo-gallery"}}),_vm._v(" "),_c('app-pagination',{attrs:{"endpoint":_vm.componentEndpoint,"pagination":_vm.pagination,"offset":4},nativeOn:{"click":function($event){_vm.getResults(_vm.pagination.current_page)}}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bd+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"silentbox-single",attrs:{"src":_vm.src},on:{"click":_vm.openSilentBoxOverlay}},[_vm._t("default"),_vm._v(" "),_c('silentbox-overlay')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ccy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("2aMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03099245_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("83hq");
function injectStyle (ssrContext) {
  __webpack_require__("lcSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03099245_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CuQm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D/yB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_StringsMixin__ = __webpack_require__("2a/y");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-sb',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_StringsMixin__["a" /* default */]],
    // Displaying photos for particular album, albumId is known
    // For gallery is 'photo'
    props: ['photos', 'albumId'],
    data: function data() {
        return {
            //
        };
    },


    computed: {
        images: function images() {
            var photos = [];
            for (var i = 0; i < this.photos.length; i++) {
                var photo = this.photos[i];
                photos[i] = {
                    src: this.photoImage(photo),
                    caption: this.albumName(photo) + ' ' + this.capitalize(photo.location_title),
                    path: __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */] + photo.album_id + '/960/' + photo.image,
                    date: photo.dateTaken,
                    location: this.capitalize(photo.location_name),
                    locationLink: photo.location_slug,
                    albumLink: this.setAlbumLink(photo),
                    photoLink: photo.slug
                };
            }
            return photos;
        },
        slug: function slug() {
            return '/galerija/album/' + this.albumId;
        }
    },

    methods: {
        setAlbumLink: function setAlbumLink(photo) {
            if (photo.album_slug) {

                return photo.album_slug;
            }
            return this.albumId;
        },
        albumName: function albumName(photo) {
            if (photo.album_name) {

                return this.capitalize(photo.album_name);
            }
            return this.capitalize(this.albumId);
        },
        photoImage: function photoImage(photo) {
            return __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */] + photo.album_id + '/300/' + photo.image;
        },

        // Clicking on overlay links - prevent displayin silentbox
        clickPriority: function clickPriority(event) {
            event.stopPropagation();
        }
    },

    created: function created() {
        console.log('silentbox gallery created');
    }
});

/***/ }),

/***/ "DDB0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_NprogressContainer_vue__ = __webpack_require__("JrlJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25953fa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_NprogressContainer_vue__ = __webpack_require__("OJd5");
function injectStyle (ssrContext) {
  __webpack_require__("H5Up")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_NprogressContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25953fa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_NprogressContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DFXp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dh71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-flex-header'
});

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SUCCESS; });
/* unused harmony export SET_LAT */
/* unused harmony export SET_LNG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_SWIPPER; });
// Shared
var SET_LOADING = 'SET_LOADING';
var SET_ERROR = 'SET_ERROR';
var CLEAR_ERROR = 'CLEAR_ERROR';
var SET_SUCCESS = 'SET_SUCCESS';

var SET_LAT = 'SET_LAT';
var SET_LNG = 'SET_LNG';

var SET_SWIPPER = 'SET_SWIPPER';

/***/ }),

/***/ "E9k1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{attrs:{"id":"silentbox-overlay"}},[_c('div',{attrs:{"id":"silentbox-overlay__background"},on:{"click":function($event){$event.stopPropagation();_vm.closeSilentboxOverlay($event)}}}),_vm._v(" "),_c('div',{attrs:{"id":"silentbox-overlay__content"},on:{"click":function($event){$event.stopPropagation();_vm.closeSilentboxOverlay($event)}}},[_c('div',{attrs:{"id":"silentbox-overlay__embed"}},[_c('div',{attrs:{"id":"silentbox-overlay__container"}},[(_vm.video)?_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.getEmbedUrl,"frameborder":"0","allowfullscreen":""}}):_vm._e(),_vm._v(" "),(! _vm.video)?_c('img',{attrs:{"width":"auto","height":"auto","src":_vm.getEmbedUrl}}):_vm._e()]),_vm._v(" "),(this.$parent.description)?_c('p',{attrs:{"id":"silentbox-overlay__description"}},[_vm._v(_vm._s(this.$parent.description))]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"silentbox-overlay__close-button","role":"button","tabindex":"3"},on:{"click":function($event){$event.stopPropagation();_vm.closeSilentboxOverlay($event)},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.closeSilentboxOverlay($event)}}},[_c('div',{staticClass:"icon"})]),_vm._v(" "),(this.$parent.items.total > 0)?_c('div',{attrs:{"id":"silentbox-overlay__arrow-buttons"}},[_c('div',{staticClass:"arrow arrow-previous",attrs:{"role":"button","tabindex":"2"},on:{"click":_vm.moveToPreviousItem,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.moveToPreviousItem($event)}}}),_vm._v(" "),_c('div',{staticClass:"arrow arrow-next",attrs:{"role":"button","tabindex":"1"},on:{"click":_vm.moveToNextItem,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.moveToNextItem($event)}}})]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EvY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StickyButton_vue__ = __webpack_require__("qbeM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0608f81e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StickyButton_vue__ = __webpack_require__("bpSX");
function injectStyle (ssrContext) {
  __webpack_require__("CuQm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StickyButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0608f81e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StickyButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FyGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlexHeaderBar_vue__ = __webpack_require__("Dh71");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57413dc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlexHeaderBar_vue__ = __webpack_require__("keRd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlexHeaderBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57413dc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlexHeaderBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GPhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar_vue__ = __webpack_require__("2dmD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppMain_vue__ = __webpack_require__("Z3XD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AppMain_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderBar_vue__ = __webpack_require__("3gIL");
/* unused harmony reexport HeaderBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar_vue__ = __webpack_require__("1O7p");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar_vue__["a"]; });









/***/ }),

/***/ "Gfxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar is-fixed-top",attrs:{"role":"navigation","aria-label":"main navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar-menu",attrs:{"id":"navMenu"}},[_c('div',{staticClass:"nav-left is-pulled-left is-flex",class:{'is-active': _vm.isActive }},[_vm._l((_vm.menuLeftItems),function(item){return _c('router-link',{key:item.title,staticClass:"navbar-item",attrs:{"to":item.link,"exact":""}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa",class:item.icon})]),_vm._v(" "+_vm._s(item.title)+"\n            ")])}),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/galerija","exact":""},nativeOn:{"click":function($event){_vm.clearGallery()}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-picture"})]),_vm._v(" Galerija\n            ")])],2),_vm._v(" "),(_vm.menu)?_c('div',{staticClass:"nav-right is-pulled-right navbar-end"},[_c('div',{staticClass:"dropdown is-hoverable"},[_c('div',{staticClass:"rel"},[_c('router-link',{staticClass:"navbar-link",attrs:{"to":"/","aria-haspopup":"true","aria-controls":"dropdown-menu4"}},[_vm._v("\n                        Lokacije\n                        "),_c('span',{staticClass:"icon is-small"})])],1),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"id":"dropdown-menu4","role":"menu"}},[_c('div',{staticClass:"dropdown-content"},_vm._l((_vm.menu.locations),function(menuItem){return _c('router-link',{key:menuItem.title,staticClass:"dropdown-item",attrs:{"to":{name: 'Location', params: {location: menuItem.slug}}}},[_vm._v("\n                            "+_vm._s(_vm._f("capitalize")(menuItem.name))+"\n                        ")])}))])]),_vm._v(" "),_c('div',{staticClass:"dropdown is-hoverable"},[_c('div',{staticClass:"rel"},[_c('router-link',{staticClass:"navbar-link",attrs:{"to":"/","aria-haspopup":"true","aria-controls":"dropdown-menu4"}},[_vm._v("\n                        MOJE ŽIVALCE\n                        "),_c('span',{staticClass:"icon is-small"})])],1),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"id":"dropdown-menu4","role":"menu"}},[_c('div',{staticClass:"dropdown-content"},_vm._l((_vm.menu.albums),function(menuItem){return _c('router-link',{key:menuItem.name,staticClass:"dropdown-item",attrs:{"to":'/' + menuItem.slug}},[_vm._v("\n                            "+_vm._s(_vm._f("capitalize")(menuItem.name))+"\n                        ")])}))])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-brand"},[_c('a',{staticClass:"navbar-burger",attrs:{"role":"button","data-target":"navMenu","aria-label":"menu","aria-expanded":"false"}},[_c('span',{attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GwZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":_vm.closeModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"box"},[_vm._t("header"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("footer")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H5Up":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"location"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),(_vm.albumLocation)?_c('div',[_c('app-header',{attrs:{"info":_vm.albumLocation.location,"title":_vm.capitalize(this.title),"imagePath":_vm.albumLocation.location.imagePath,"isType":"location"}}),_vm._v(" "),(_vm.albumLocation.photos)?_c('div',{staticClass:"bg-dark1"},[_c('app-sb',{attrs:{"photos":_vm.albumLocation.photos,"albumId":"3"}}),_vm._v(" "),_c('h3',{staticClass:"links"},[_c('router-link',{attrs:{"to":"/galerija"}},[_vm._v("Vse slike ")])],1)],1):_vm._e(),_vm._v(" "),_c('app-google-map',{attrs:{"mapName":_vm.capitalize(this.title)}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I/oh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ILy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlay_vue__ = __webpack_require__("h34B");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxGroup',
    data: function data() {
        return {
            overlayVisibility: false,
            embedUrl: '',
            items: {
                total: 0,
                position: 0,
                list: []
            },
            autoplay: false,
            description: ''
        };
    },

    watch: {
        /**
         * Update total number of items when object changes.
         *
         * @param  {Object} current
         * @param  {Object} old
         * @return {void}
         */
        'items.list': function itemsList(current, old) {
            this.updateTotal(current);
        }
    },
    methods: {
        /**
         * Update count of total items in group.
         *
         * @param  {object} items
         * @return {void}
         */
        updateTotal: function updateTotal(items) {
            this.items.total = this.items.list.length;
        },

        /**
         * Move to next item in a group.
         *
         * @return {void}
         */
        nextItem: function nextItem() {
            if (this.items.position !== this.items.total - 1) {
                this.items.position++;
            } else {
                this.items.position = 0;
            }

            this.embedUrl = this.items.list[this.items.position].src;

            this.autoplay = this.items.list[this.items.position].autoplay !== undefined ? this.items.list[this.items.position].autoplay : false;

            this.description = this.items.list[this.items.position].desc !== undefined ? this.items.list[this.items.position].desc : false;
        },

        /**
         * Move to previous item in a group.
         *
         * @return {void}
         */
        prevItem: function prevItem() {
            if (this.items.position !== 0) {
                this.items.position--;
            } else {
                this.items.position = this.items.total - 1;
            }

            this.embedUrl = this.items.list[this.items.position].src;

            this.autoplay = this.items.list[this.items.position].autoplay !== undefined ? this.items.list[this.items.position] : false;

            this.description = this.items.list[this.items.position].desc !== undefined ? this.items.list[this.items.position].desc : false;
        },

        /**
         * Set item that shuld be displayed.
         *
         * @return {void}
         */
        setOpened: function setOpened(item) {
            this.embedUrl = item.url;
            this.items.position = item.position;
            this.overlayVisibility = true;
            this.autoplay = item.autoplay;
            this.description = item.description;
        }
    },
    components: {
        'silentbox-overlay': __WEBPACK_IMPORTED_MODULE_0__overlay_vue__["a" /* default */]
    },
    mounted: function mounted() {
        var _this = this;

        // Hide overlay when user click outside or on close button.
        this.$on('closeSilentboxOverlay', function () {
            _this.overlayVisibility = false;
        });

        // Set first opened item when overlay opens.
        this.$on('openSilentboxOverlay', function (item) {
            _this.setOpened(item);
        });

        // Update total number of available items in group.
        this.updateTotal(this.items);

        // Listen to key events.
        window.addEventListener('keyup', function (event) {
            // Escape: 27
            if (event.which === 27) {
                _this.overlayVisibility = false;
            }
            // Right arrow: 39
            if (event.which === 39) {
                _this.nextItem();
            }
            // Left arrow: 37
            if (event.which === 37) {
                _this.prevItem();
            }
        });
    }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_shared__ = __webpack_require__("tnqL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_menu__ = __webpack_require__("egBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_home__ = __webpack_require__("xQAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_photos__ = __webpack_require__("zSBs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_posts__ = __webpack_require__("QSQN");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    // strict: true,  // process.env.NODE_ENV !== 'production',
    strict: debug,
    // actions,
    // getters,
    modules: {
        sharedStore: __WEBPACK_IMPORTED_MODULE_2__modules_shared__["a" /* default */],
        menuStore: __WEBPACK_IMPORTED_MODULE_3__modules_menu__["a" /* default */],
        homeStore: __WEBPACK_IMPORTED_MODULE_4__modules_home__["a" /* default */],
        photosStore: __WEBPACK_IMPORTED_MODULE_5__modules_photos__["a" /* default */],
        postsStore: __WEBPACK_IMPORTED_MODULE_6__modules_posts__["a" /* default */]
    },
    state: {},
    mutations: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "JbSO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JrlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nprogress-container'
});

/***/ }),

/***/ "Ju3D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Silentbox_vue__ = __webpack_require__("VCW7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35daf6e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Silentbox_vue__ = __webpack_require__("gRIS");
function injectStyle (ssrContext) {
  __webpack_require__("A8vF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Silentbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35daf6e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Silentbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K/6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"map-frame"},[_c('div',{staticClass:"google-map",attrs:{"id":"google-map"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KWRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gallery-photo-page"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),(_vm.albumPhoto !== null && _vm.albumPhoto.hasOwnProperty('photo'))?_c('div',[_c('app-header',{attrs:{"info":_vm.albumPhoto.photo,"title":_vm.capitalize(_vm.title),"imagePath":_vm.imagePath,"isType":"photo","isClass":"is-fullheight1"}}),_vm._v(" "),_c('div',{staticClass:"columns nav-container mtb-80 rel"},[_c('div',{staticClass:"breadcrumbs-parent",staticStyle:{"left":"20px","display":"flex"}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/galerija"}},[_vm._v("Galerija")])],1),_vm._v(" "),_c('li',{domProps:{"textContent":_vm._s(_vm.capitalize(_vm.title))}})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"wide has-text-centered"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.albumPhoto.prev.location.name)))]),_vm._v(" "),_c('p',{staticClass:"intro has-text-centered"},[_vm._v(_vm._s(_vm.albumPhoto.prev.date))]),_vm._v(" "),(_vm.albumPhoto.prev)?_c('a',{staticClass:"prev",attrs:{"href":_vm.albumPhoto.prev.slug}},[_c('img',{attrs:{"src":_vm.getPhoto(_vm.albumPhoto.prev),"alt":_vm.albumPhoto.prev.name}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column special-blockquote complex-line column"},[_c('span',{staticClass:"related weather"}),_vm._v(" "),_c('blockquote',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(_vm.albumPhoto.quote.quote))]),_vm._v(" "),_c('cite',[_vm._v(_vm._s(_vm.albumPhoto.quote.author))])])]),_vm._v(" "),_c('div',{staticClass:"column has-text-right"},[_c('p',{staticClass:"wide has-text-centered"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.albumPhoto.next.location.name)))]),_vm._v(" "),_c('p',{staticClass:"intro has-text-centered"},[_vm._v(_vm._s(_vm.albumPhoto.prev.date))]),_vm._v(" "),(_vm.albumPhoto.next)?_c('a',{staticClass:"next",attrs:{"href":_vm.albumPhoto.next.slug}},[_c('img',{attrs:{"src":_vm.getPhoto(_vm.albumPhoto.next),"alt":_vm.albumPhoto.next.name}})]):_vm._e()])]),_vm._v(" "),_c('h3',{staticClass:"links"},[_c('a',{attrs:{"href":_vm.slug}},[_vm._v("Vse slike")])]),_vm._v(" "),_c('app-google-map',{attrs:{"mapName":_vm.capitalize(this.title),"glat":_vm.albumPhoto.photo.location.lat,"glng":_vm.albumPhoto.photo.location.lng}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LSlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("vOxz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a39c1cfc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("952d");
function injectStyle (ssrContext) {
  __webpack_require__("aBe7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a39c1cfc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LeuH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("1H2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000053b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("P4kN");
function injectStyle (ssrContext) {
  __webpack_require__("mrMk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000053b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lt18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M7uO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-footer',
    data: function data() {
        // Package details
        return {
            footerMenu: [{ icon: '', title: 'Domov', link: '/' }, { icon: '', title: 'O nas', link: '/o-nas' }, { icon: '', title: 'Kontakt', link: '/kontakt' }, { icon: '', title: 'Blog', link: '/blog' }, { icon: '', title: 'Galerija', link: '/galerija' }]

        };
    },

    computed: {
        getYear: function getYear() {
            var dt = new Date();
            return dt.getFullYear();
        }
    }

});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Vq/C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MlxK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_single_vue__ = __webpack_require__("mqsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e0d80dca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_single_vue__ = __webpack_require__("Bd+9");
function injectStyle (ssrContext) {
  __webpack_require__("I/oh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_single_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e0d80dca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_single_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N/At":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            openedModal: null
        };
    },


    methods: {
        openModal: function openModal(id) {
            if (id === null || id === undefined) {
                console.log('Modal: ID is not defined');
                return;
            }

            this.openedModal = id;
        },
        closeModal: function closeModal() {
            this.openedModal = null;
            // console.log('CLOSE modal mixin')
            this.$emit('close');
        }
    }
});

/***/ }),

/***/ "ODdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryAlbum_vue__ = __webpack_require__("+xmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7541fdf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryAlbum_vue__ = __webpack_require__("4ewA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryAlbum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7541fdf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryAlbum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OJd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nprogress-container"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Op8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_gmaps_GoogleMaps_vue__ = __webpack_require__("ixP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['location'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        console.log('location L : ', this.location);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'location/' + this.location
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-google-map': __WEBPACK_IMPORTED_MODULE_4__components_elements_gmaps_GoogleMaps_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_6__components_layout_BackButton_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['albumLocation', 'loading', 'error', 'title'])),

    methods: {
        fetchLocation: function fetchLocation() {

            this.$store.dispatch('fetchLocation', this.endpoint);
        }
    },

    created: function created() {
        if (this.albumLocation === null || this.albumLocation.location.slug !== this.location) {

            this.fetchLocation();
        }
        // document.title = this.capitalize(this.location);
        // console.log('General location - Component created.', this.albumLocation, this.location, this.albumLocation)
    },
    beforeUpdate: function beforeUpdate() {
        // console.log('before update location l coming from navbar', this.albumLocation);
    }
});

/***/ }),

/***/ "P4cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post)?_c('section',{staticClass:"section lightbg-panel"},[_c('div',{staticClass:"columns is-desktop mb-40"},[_c('div',{staticClass:"column"},[_vm._m(0),_vm._v(" "),_c('app-contact-form')],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"post-content boxs"},[_c('h3',{staticClass:"is-4"},[_c('a',{attrs:{"href":_vm.post.link}},[_vm._v(_vm._s(_vm.post.title))])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.post.content)}}),_vm._v(" "),_c('a',{staticClass:"general-link",attrs:{"href":"/blog"}},[_vm._v("Vsi članki")])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rel"},[_c('div',{staticClass:"f-ribbon"},[_c('span',[_vm._v("Piši nam")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P4kN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pagination is-right",attrs:{"role":"navigation","aria-label":"pagination"}},[_c('ul',{staticClass:"pagination-list"},[(_vm.pagination.current_page > 1)?_c('li',{staticClass:"pagination-link"},[_c('a',{staticClass:"pagination-previous",attrs:{"aria-label":"First","href":_vm.endpoint + '/1'}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("««")])]),_vm._v(" "),_c('a',{staticClass:"pagination-previous",attrs:{"aria-label":"Previous","href":_vm.endpoint + '/' + (_vm.pagination.current_page - 1)}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("«")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pagesNumber),function(page){return _c('li',{class:_vm.getClass(page)},[(_vm.pagination.current_page === page)?_c('span',{on:{"click":function($event){$event.preventDefault();_vm.preventClick($event)}}},[_vm._v(_vm._s(page))]):_c('a',{attrs:{"aria-label":"Current","href":_vm.endpoint + '/' + page}},[_vm._v(_vm._s(page))])])}),_vm._v(" "),(_vm.pagination.current_page < _vm.pagination.last_page)?_c('li',{staticClass:"pagination-link"},[_c('a',{staticClass:"pagination-next",attrs:{"href":_vm.endpoint + '/' + (_vm.pagination.current_page + 1)}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("»")])]),_vm._v(" "),_c('a',{staticClass:"pagination-next",attrs:{"href":_vm.endpoint + '/' + _vm.pagination.last_page}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("»»")])])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PEfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("goMg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca60efb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("GwZh");
function injectStyle (ssrContext) {
  __webpack_require__("JbSO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca60efb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PN5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),(_vm.albumMain)?_c('div',[_c('app-header',{attrs:{"info":_vm.albumMain.album,"title":_vm.title,"imagePath":_vm.albumMain.album.imagePath,"isType":"album","shortDesc":_vm.albumMain.album.short_description}}),_vm._v(" "),(_vm.albumMain.album.description)?_c('div',{staticClass:"custom-description",domProps:{"innerHTML":_vm._s(_vm.albumMain.album.description)}}):_vm._e(),_vm._v(" "),(_vm.albumMain.album.extra_description)?_c('div',{staticClass:"custom-description",domProps:{"innerHTML":_vm._s(_vm.albumMain.album.extra_description)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"custom-description"},[(_vm.albumMain.album.id === 1 || _vm.albumMain.album.id === 2)?_c('silentbox-single',{attrs:{"src":_vm.pedigreePath(_vm.albumMain.album.id, _vm.albumMain.album.slug + '-pedigree-sl.jpg', true),"autoplay":true,"description":_vm.capitalize(_vm.albumMain.album.name) + ' Pedigree'}},[_c('img',{attrs:{"src":_vm.pedigreePath(_vm.albumMain.album.id, _vm.albumMain.album.slug + '-pedigree-sl.jpg', false)}})]):_vm._e()],1),_vm._v(" "),(_vm.albumMain.photos)?_c('div',{staticClass:"bg-light ptb-80"},[_c('app-sb',{attrs:{"photos":_vm.albumMain.photos,"albumId":_vm.id}})],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pel+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogCategories_vue__ = __webpack_require__("tuEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b3852d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogCategories_vue__ = __webpack_require__("viyr");
function injectStyle (ssrContext) {
  __webpack_require__("aW87")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b3852d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QFAX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QNom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blog-page"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),_c('app-flex-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container is-fluid bottom-header"},[_c('app-mail-categories-sticky',{attrs:{"items":_vm.postsCategories}})],1),_vm._v(" "),_c('div',{staticClass:"container is-fluid"},[_c('section',{staticClass:"articles columns is-multiline"},_vm._l((_vm.posts),function(post){return _c('div',{key:post.title,staticClass:"column mt-10 is-full-mobile is-half-tablet is-one-third-desktop shadowing"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-content has-text-centered"},[_c('p',{staticClass:"title article-title"},[_c('router-link',{attrs:{"to":'/blog/' + post.category.slug + '/' + post.slug}},[_vm._v("\n                                     "+_vm._s(_vm._f("capitalize")(post.title))+"\n                                 ")])],1),_vm._v(" "),_c('router-link',{staticClass:"article-cat",attrs:{"to":'/blog/' + post.category.slug,"exact":""}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-tag"})]),_vm._v(" "+_vm._s(post.category.name)+"\n                             ")]),_vm._v(" "),_c('div',{staticClass:"tags has-addons level-item"},[_c('span',{staticClass:"tag is-rounded is-success1"},[_vm._v("@"+_vm._s(post.user.first_name)+" "+_vm._s(post.user.last_name)+" ")]),_vm._v(" "),_c('span',{staticClass:"tag is-rounded"},[_vm._v("\n                                     "+_vm._s(post.created)+"\n                                 ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"content article-body",domProps:{"innerHTML":_vm._s(post.content)}})]),_vm._v(" "),_c('div',{staticClass:"card-foot"},[_c('hr'),_vm._v(" "),_c('app-centered-button',{attrs:{"link":'/blog/' + post.category.slug + '/' + post.slug,"text":"Beri naprej"}})],1)])}))])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abs",staticStyle:{"top":"200px","left":"50px"}},[_c('h1',{staticClass:"title has-text-limegreen",staticStyle:{"padding":"20px","background":"rgba(0,0,0,0.3)"}},[_vm._v("Blog o nemških ovčarjih, o Tesi, Oli, Lučki in Figaru, našemu mucu")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QSQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// for albums, locations, photos



/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * States
     */
    state: {
        postsCategory: null,
        posts: null,
        post: null,
        postsCategories: null,
        postsLinks: null,
        endpoint: '',
        title: ''
    },

    /**
     * Mutations
     */
    mutations: {
        setPostsCategory: function setPostsCategory(state, payload) {
            state.postsCategory = payload;
        },
        setPost: function setPost(state, payload) {
            state.post = payload;
        },
        setPosts: function setPosts(state, payload) {
            state.posts = payload;
        },
        setPostsCategories: function setPostsCategories(state, payload) {
            state.postsCategories = payload;
        },
        setPostsLinks: function setPostsLinks(state, payload) {
            state.postsLinks = payload;
        }
    },

    /**
     * Getters
     */
    getters: {
        post: function post(state) {
            return state.post;
        },
        posts: function posts(state) {
            return state.posts;
        },
        postsCategories: function postsCategories(state) {
            return state.postsCategories;
        },
        postsCategory: function postsCategory(state) {
            return state.postsCategory;
        },
        postsLinks: function postsLinks(state) {
            return state.postsLinks;
        }
        // title (state) {
        //     return state.title;
        // },

    },

    /**
     * Actions
     */
    actions: {
        fetchPosts: function fetchPosts(_ref, payload) {
            var commit = _ref.commit,
                getters = _ref.getters;

            console.log('fetch posts time: ', Date.now(), payload);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // console.log('RESPONSE posts: ' , response.data);

                if (response.data !== undefined) {
                    if (response.data.hasOwnProperty('category')) {
                        commit('setPostsCategory', response.data.category);
                    }
                    commit('setPosts', response.data.posts);
                    commit('setPostsCategories', response.data.categories);

                    commit('setTitle', response.data.posts.name);

                    // set meta description, meta keywords
                    if (_typeof(response.data.metas) === undefined) {
                        console.log('type of metas undefined: ', response.data);
                    }
                    if (typeof response.data.metas === 'undefined') {
                        console.log('type of metas undefined: ', response.data);
                    }
                    if (response.data.hasOwnProperty('metas')) {
                        console.log('metas property ok: ', response.data);
                    }

                    if (response.data.hasOwnProperty('metas') && response.data.metas === '') {
                        console.log('metas property ok but empty: ');
                    }

                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                }
            }).catch(function (error) {
                // console.log('STORE error fetching location: ',error.response);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // commit(SET_ERROR, error.response.data.errors.error);
            });
        },
        fetchPost: function fetchPost(_ref2, payload) {
            var commit = _ref2.commit,
                getters = _ref2.getters;

            // post/12
            // console.log('time: ', Date.now(), payload);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // console.log('RESPONSE posts: ' , response.data.posts);

                if (response.data !== undefined) {
                    var data = response.data;
                    // commit('setItems', data);
                    commit('setPost', data.post);
                    commit('setPostsCategories', data.categories);
                    commit('setTitle', data.post.title);
                    commit('setPostsLinks', response.data.links);

                    // set meta description, meta keywords
                    document.head.querySelector('meta[name=description]').content = data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = data.metas.meta_keywords;
                    document.title = data.metas.meta_title;
                    // console.log(this.getters, response.data.post);
                }
            }).catch(function (error) {
                console.log('STORE error fetching location: ', error.response);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // commit(SET_ERROR, error.response.data.errors.error);
            });
        }
    }

});

/***/ }),

/***/ "RDwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaFooter_vue__ = __webpack_require__("zn69");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55050777_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaFooter_vue__ = __webpack_require__("P4cb");
function injectStyle (ssrContext) {
  __webpack_require__("iKIO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55050777"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CaFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55050777_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CaFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SSiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-page"}},[_c('app-flex-header'),_vm._v(" "),(_vm.items.page)?_c('section',{staticClass:"hero is-default animated"},[_c('div',{staticClass:"hero-body"},[_c('h1',{staticClass:"title mt-80 down-line wide"},[_vm._v(_vm._s(_vm.items.page.name))])])]):_vm._e(),_vm._v(" "),(_vm.items.page)?_c('section',{staticClass:"section about"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.items.page.description)}})]):_vm._e(),_vm._v(" "),(_vm.items.quote)?_c('app-action-call-general',{attrs:{"quote":_vm.items.quote}}):_vm._e(),_vm._v(" "),(_vm.items.post)?_c('app-action-call-footer',{attrs:{"post":_vm.items.post}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T0K0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_item_vue__ = __webpack_require__("7hk8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7008e526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_item_vue__ = __webpack_require__("AEdf");
function injectStyle (ssrContext) {
  __webpack_require__("AiQ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7008e526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1tQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 *  Converts a string into Capitalize
 *
 * 'abc' => 'Abc'
 */

function capitalize(value) {
  if (!value && value !== 0) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/* harmony default export */ __webpack_exports__["a"] = (capitalize);

/***/ }),

/***/ "TfSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quote)?_c('section',{staticClass:"section"},[_c('div',{staticClass:"columns is-desktop mtb-80"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column max-width",attrs:{"id":"weather"}},[_c('app-weather',{attrs:{"language":"sl-si","title":"današnje vreme"}})],1),_vm._v(" "),_c('div',{staticClass:"special-blockquote complex-line column",class:_vm.classObj},[_c('span',{staticClass:"related weather"}),_vm._v(" "),_c('blockquote',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(_vm.quote.quote))]),_vm._v(" "),_c('cite',[_vm._v(_vm._s(_vm.quote.author))])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column mb-40"},[_c('span',{staticClass:"title-icon fa fa-warning fa-2x center has-text-danger"}),_vm._v(" "),_c('h3',{staticClass:"dotted-line is-size-5 has-text-weight-bold"},[_vm._v("Pomembno")]),_vm._v(" "),_c('p',{staticClass:"has-text-centered"},[_vm._v("POZOR - ko odhajate v naravo: skrbno pazite na vaše ljubljenčke in imejte telefonsko številko veterinarja vedno pri sebi.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TgOZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__ = __webpack_require__("mll2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc00854_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__ = __webpack_require__("aIdE");
function injectStyle (ssrContext) {
  __webpack_require__("XAgJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc00854_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U0mI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-backbuttton',
    props: ['title'],
    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        }
    }
});

/***/ }),

/***/ "UOlw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_card_AlbumCard_vue__ = __webpack_require__("ePne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_swipper_Swipper__ = __webpack_require__("kXWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_complex_CaGeneral__ = __webpack_require__("0Obv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_complex_CaFooter__ = __webpack_require__("RDwC");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'app-card': __WEBPACK_IMPORTED_MODULE_2__components_elements_card_AlbumCard_vue__["a" /* default */],
        'app-swipper': __WEBPACK_IMPORTED_MODULE_3__components_elements_swipper_Swipper__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_4__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-action-call-general': __WEBPACK_IMPORTED_MODULE_5__components_complex_CaGeneral__["a" /* default */],
        'app-action-call-footer': __WEBPACK_IMPORTED_MODULE_6__components_complex_CaFooter__["a" /* default */]
    },

    data: function data() {
        // console.log('route id: ', this.$route.params.id);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'main',
            linkAlbums: '/albums/',
            linkPhotos: '/photos/',
            defaultUrl: __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */] + '300/logo.png'
        };
    },


    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['items', 'error', 'loading']), {
        imageUrl: function imageUrl() {
            if (this.items.photoQuote) {
                return '<img src="' + __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */] + this.items.photoQuote.album_id + '/300/' + this.items.photoQuote.image + '" />';
            }
            return;
        }
    }),

    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['clearError', 'setError', 'clearNotification']), {
        fetchHome: function fetchHome() {
            this.$store.dispatch('fetchItems', this.endpoint);
        }
    }),
    created: function created() {
        // this.$store.dispatch('clearNotification');
        // this.$store.dispatch('clearError');
        this.fetchHome();
        // console.log('created home');
    }
});

/***/ }),

/***/ "VCW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_StringsMixin__ = __webpack_require__("2a/y");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-sb',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_StringsMixin__["a" /* default */]],
    // Displaying photos for particular album, albumId is known
    // For gallery is 'photo'
    props: ['photos', 'albumId'],
    data: function data() {
        // console.log('albumId: ', this.albumId);
        return {
            //
        };
    },


    computed: {
        images: function images() {
            var photos = [];
            for (var i = 0; i < this.photos.length; i++) {
                var photo = this.photos[i];
                photos[i] = {
                    src: this.photoImage(photo),
                    caption: this.albumName(photo) + ' ' + this.capitalize(photo.location_title),
                    path: __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */] + photo.album_id + '/960/' + photo.image,
                    date: photo.dateTaken,
                    location: this.capitalize(photo.location_name),
                    locationLink: photo.location_slug,
                    albumLink: this.setAlbumLink(photo),
                    photoLink: photo.slug
                };
            }
            return photos;
        },
        slug: function slug() {
            return __WEBPACK_IMPORTED_MODULE_0__env__["d" /* GalleryAlbumLink */] + this.albumId;
        }
    },

    methods: {
        setAlbumLink: function setAlbumLink(photo) {
            if (photo.album_slug) {
                return photo.album_slug;
            }
            return this.albumId;
        },
        albumName: function albumName(photo) {
            if (photo.album_name) {

                return this.capitalize(photo.album_name);
            }
            return this.capitalize(this.albumId);
        },
        photoImage: function photoImage(photo) {
            return photo.imagePath;
        },

        // Clicking on overlay links - prevent displayin silentbox
        clickPriority: function clickPriority(event) {
            event.stopPropagation();
        }
    },

    created: function created() {
        // console.log('silentbox created');
    }
});

/***/ }),

/***/ "VGM0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{staticClass:"clearfix",attrs:{"name":"fade"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"notification",class:_vm.classObj},[_vm._v("\n        "+_vm._s(_vm.message)+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VHrM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts a string to UPPERCASE
 *
 * 'abc' => 'ABC'
 */

function uppercase(value) {
  return value || value === 0 ? value.toString().toUpperCase() : '';
}

/* harmony default export */ __webpack_exports__["a"] = (uppercase);

/***/ }),

/***/ "VatP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_pagination_Pagination_vue__ = __webpack_require__("LeuH");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['page'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        // console.log(this.page, this.p);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'gallery',
            endpointSearch: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'searchGallery',
            photoUrl: __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */],
            query: '',
            errorClass: '',
            size: '/1960/'
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__["a" /* default */],
        'app-pagination': __WEBPACK_IMPORTED_MODULE_6__components_elements_pagination_Pagination_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['gallery', 'loading', 'error', 'title', 'paginate', 'pagination']), {
        imagePath: function imagePath() {
            // console.log('image path: ', PhotoUrl);
            return __WEBPACK_IMPORTED_MODULE_0__env__["f" /* PhotoUrl */] + this.gallery.album_id + this.size;
        },
        galleryPhotos: function galleryPhotos() {
            // console.log('gallery photos: ', this.gallery.photos);
            return this.gallery.photos;
        },
        componentEndpoint: function componentEndpoint() {
            return '/galerija/p';
        },
        searchError: function searchError() {
            if (this.query !== '' && this.gallery.error && this.gallery.error !== '') {
                console.log(' error for filters ');
                this.errorClass = '';
                return true;
            }
            this.errorClass = 'is-hidden';
            return false;
        }
    }),

    methods: {
        /**
         * get paginated results - for page > 1
         * paginate - navigation click
         */
        getResults: function getResults(page) {
            if (typeof page === 'undefined') {
                page = 2;
            }
            // let endpoint = this.endpoint;

            page = this.page;
            var endpoint = this.endpoint + '/p/' + page;

            var data = {
                endpoint: endpoint,
                page: this.page,
                type: 'gallery'
            };
            // console.log('gallery getResults: ', endpoint, ' page: ', page, 'this.page: ', this.page);
            this.$store.dispatch('getPaginatedItems', data);
        },
        fetchAlbumPhotos: function fetchAlbumPhotos() {
            var endpoint = this.endpoint;

            var page = this.page;
            if (typeof this.page === 'undefined') {
                // console.log('PAGE undefined');
                page = 1;
            }

            var data = {
                endpoint: endpoint,
                page: page,
                type: 'gallery',
                album: ''
            };

            endpoint = this.endpoint + '/p/' + page;
            data.endpoint = endpoint;

            // console.log('PAGE undefined? ', data);
            this.$store.dispatch('fetchGallery', data);
        },
        clear: function clear() {
            this.query = '';
            this.$store.dispatch('clearNotification');
            this.$store.dispatch('clearError');
            this.fetchAlbumPhotos();
        },
        submitPrevent: function submitPrevent(event) {
            // console.log('prevent submit: ', event);
            event.stopPropagation();
            event.preventDefault();
            // return false;
        },


        /**
         * live search
         */
        itemFilter: function itemFilter() {
            var self = this;
            if (self.query === '') {
                // console.log('empty query, page: ', this.page);
                // this.fetchPhoto();
                this.fetchAlbumPhotos();
            } else {
                var first = 'name';
                var second = 'description';
                var third = '';

                // if(this.link === '/photos/') {
                first = 'name';
                second = 'album_id';
                third = 'location_id';
                // }
                this.endpoint = this.endpointSearch;
                var data = {
                    field: [first, second],
                    value: self.query,
                    endpoint: this.endpoint
                };

                this.$store.dispatch('fetchGalleryFilter', data);
            }
        }
    },

    created: function created() {
        this.itemFilter();
        // document.title = this.capitalize(this.photo);
        // console.log('Gallery - Component mounted.')
    }
});

/***/ }),

/***/ "Vq/C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"page-wrapper"}},[_c('navbar'),_vm._v(" "),_c('nprogress-container'),_vm._v(" "),_c('progress',{staticClass:"progress is-small is-primary",attrs:{"max":"100"}},[_vm._v("15%")]),_vm._v(" "),_c('app-main')],1),_vm._v(" "),_c('footer-bar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W+dz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts a string to lowercase
 *
 * 'AbC' => 'abc'
 */

function lowercase(value) {
  return value || value === 0 ? value.toString().toLowerCase() : '';
}

/* harmony default export */ __webpack_exports__["a"] = (lowercase);

/***/ }),

/***/ "WU/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SilentboxGallery_vue__ = __webpack_require__("D/yB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbd66fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SilentboxGallery_vue__ = __webpack_require__("jIKI");
function injectStyle (ssrContext) {
  __webpack_require__("DFXp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SilentboxGallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbd66fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SilentboxGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XAgJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home_vue__ = __webpack_require__("j7e0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_About_vue__ = __webpack_require__("vu9I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Contact_vue__ = __webpack_require__("Ccy0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_blog_Blog_vue__ = __webpack_require__("i8Ld");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_blog_BlogCategories_vue__ = __webpack_require__("Pel+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_blog_BlogPost_vue__ = __webpack_require__("TgOZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_albums_Album_vue__ = __webpack_require__("qK3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_albums_AlbumLocation_vue__ = __webpack_require__("5emR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_albums_AlbumPhoto_vue__ = __webpack_require__("+wi3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_gallery_Gallery_vue__ = __webpack_require__("4WGV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_gallery_GalleryAlbum_vue__ = __webpack_require__("ODdD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_gallery_GalleryPhoto_vue__ = __webpack_require__("/Ulc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_locations_Location_vue__ = __webpack_require__("gDK1");











/*albums display particular album, with photos and locations for particular album*/



/*photos display all photos, with filter for albums and locations*/



/*locations display all locations, add filters for albums*/


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
    name: 'Domov',
    path: '/',
    // use vue ext if you have setup outside the laravel
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log('home route: ' , route.name);
            return route.name;
        },
        transitionName: 'zoomIn'
    }
}, {
    name: 'O nas',
    path: '/o-nas',
    component: __WEBPACK_IMPORTED_MODULE_3__views_About_vue__["a" /* default */],
    meta: {
        title: function title(route) {
            return route.name;
        },
        transitionName: 'fadeOutUp'
    }
}, {
    name: 'Kontakt',
    path: '/kontakt',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Contact_vue__["a" /* default */],
    meta: {
        title: function title(route) {
            return route.name;
        }
    }
}, {
    path: '/blog',
    name: 'Blog',
    component: __WEBPACK_IMPORTED_MODULE_5__views_blog_Blog_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            return route.name;
        },
        transitionName: 'fadeInRight'
    }
}, {
    path: '/blog/:category',
    name: 'BlogCategories',
    component: __WEBPACK_IMPORTED_MODULE_6__views_blog_BlogCategories_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            return route.name;
        },
        transitionName: 'zoomIn'
    }
}, {
    path: '/blog/:categorySlug/:postSlug',
    name: 'BlogPost',
    component: __WEBPACK_IMPORTED_MODULE_7__views_blog_BlogPost_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            return route.name;
        },
        transitionName: 'slideInRigth'
    }
},

// Gallery
{
    path: '/galerija',
    name: 'Galerija',
    component: __WEBPACK_IMPORTED_MODULE_11__views_gallery_Gallery_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log('plain gallery');
            return route.name;
        }
    }
},
// in .htaccess redirect galerija?page=... with new paths galerija/p/..
{
    path: '/galerija/p/:page',
    name: 'galleryPage',
    component: __WEBPACK_IMPORTED_MODULE_11__views_gallery_Gallery_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log('page gallery');
            return route.name;
        }
    }
},
// external link, do we need children links?
{
    path: '/galerija/album/:album/:page?',
    name: 'galleryAlbum',
    component: __WEBPACK_IMPORTED_MODULE_12__views_gallery_GalleryAlbum_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log('here we are-album path: ', route.path);
            return route.name;
        }
    }
},
// this MUST exist for the SEO - indexed images from old page
{
    path: '/galerija/:photo',
    name: 'galleryPhotos',
    component: __WEBPACK_IMPORTED_MODULE_13__views_gallery_GalleryPhoto_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log('here we are-photo path: ', route.path);
            return route.name;
        }
    }
},
/*{
    path: '/galerija',
    name: 'Gallery',
    component: Gallery,
    children: [
        // {
        //   path: 'album/:album/:p?',
        //   name: 'galleryAlbums',
        //   component: GalleryAlbum,
        //   props: { albumDetails: true, photoDetails: false }
        // },
        // {
        //   path: ':photo',
        //   name: 'galleryPhotos',
        //   component: GalleryPhoto,
        //   props: { photoDetails: true, albumDetails: false }
        // },
    ]
},*/

{
    path: '/:id',
    name: 'Album',
    component: __WEBPACK_IMPORTED_MODULE_8__views_albums_Album_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log('album route: ' , route.params.id);
            return route.params.id;
        }
    }

    // Append additional oontent to parent, don't forget to add
    // router-view in parent component!!
    /*children: [
        {
            path: ':location',
            name: 'AlbumLocation',
            component: AlbumLocation,
            props: true,
            meta: {
                title: route => {
                    console.log('children route Alocation: ', route.params.id)
                    console.log('route: ' , route.params.location);
                    return route.location + ' ' + (route.params.location)
                }
            }
        },
        {
            path: ':photo',
            name: 'AlbumPhoto',
            component: AlbumPhoto,
            props: true,
            meta: {
                title: route => {
                    console.log('children route Aphoto: ', route.params.photo)
                    return route.name + ' ' + (route.params.photo) }
            }
        },
    ]*/
}, {
    path: '/l/:location',
    name: 'Location',
    component: __WEBPACK_IMPORTED_MODULE_14__views_locations_Location_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log(' route just location: ', route.params.location)
            // console.log('route: ' , route.params.location);
            return route.params.location;
        }
    }
}, {
    path: '/:album/:location',
    name: 'AlbumLocation',
    component: __WEBPACK_IMPORTED_MODULE_9__views_albums_AlbumLocation_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log(' route Alocation: ', route.params.location)
            // console.log('route: ' , route.params.location);
            return route.params.location;
        }
    }
}, {
    path: '/:album/:location/:photo',
    name: 'AlbumPhoto',
    component: __WEBPACK_IMPORTED_MODULE_10__views_albums_AlbumPhoto_vue__["a" /* default */],
    props: true,
    meta: {
        title: function title(route) {
            // console.log(' route Aphoto: ', route.params.photo, route.name)
            return route.params.photo;
        }
    }
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: routes,
    mode: 'history',
    history: true,
    linkActiveClass: 'is-active',
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Z3XD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__ = __webpack_require__("nsC1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127589f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__ = __webpack_require__("x03M");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127589f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZMsq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-swipper',
    components: {
        swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {

        return {
            swiperOption: {
                watchOverflow: true,
                // some swipper options
                // lazy: true,
                speed: 600,
                parallax: true,
                // observer: true,
                // observeParents: true,
                loop: true,
                // effect: 'fade',
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: true
                },
                initialSlide: 0,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'progressbar'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        };
    },


    computed: {
        swiper: function swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },

    mounted: function mounted() {
        // current swiper instance
        // console.log('this is current swiper instance object', this.swiper);
        // this.swiper.slideTo(3, 1000, true)
    }
});

/***/ }),

/***/ "ZuEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleMaps__ = __webpack_require__("lylM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-google-map',
    props: {
        'mapName': {
            type: String,
            default: function _default() {
                return 'Doma';
            }
        },
        'glat': {
            type: String,
            default: function _default() {
                return '';
            }
        },
        'glng': {
            type: String,
            default: function _default() {
                return '';
            }
        },
        'zoom': {
            type: Number,
            default: function _default() {
                return 15;
            }
        }
    },

    data: function data() {
        return {
            //
        };
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['loading', 'error', 'lat', 'lng'])),

    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setLat', 'setLng']), {
        setLat: function setLat() {
            if (this.glat !== '' || this.glat !== undefined) {
                this.$store.dispatch('setLat', this.glat);
            }
        },
        setLng: function setLng() {
            if (this.glng !== '' || this.glng !== undefined) {
                this.$store.dispatch('setLng', this.glng);
            }
        }
    }),
    // For dropdown locations
    mounted: function mounted() {
        var opt = {
            lat: this.lat,
            lng: this.lng,
            zoom: this.zoom,
            name: this.mapName
        };
        var gmaps = new __WEBPACK_IMPORTED_MODULE_0__GoogleMaps__["a" /* default */](opt);
        // console.log('Gmap mounted: ', this.lat, this.lng, ' end', this.glat, this.glng);
        gmaps.drawMap();
    },


    // For images location (AlbumLocation) - links on images (home)
    beforeUpdate: function beforeUpdate() {
        var opt = {
            lat: this.lat,
            lng: this.lng,
            zoom: this.zoom,
            name: this.mapName
        };
        var gmaps = new __WEBPACK_IMPORTED_MODULE_0__GoogleMaps__["a" /* default */](opt);
        gmaps.drawMap();
        // console.log('Gmap beforeUpdate: ', this.lat, this.lng, this.glat, this.glng);
    }
});

/***/ }),

/***/ "aBe7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aIdE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blog-post-page"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),_c('section',{staticClass:"hero is-info is-medium is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.blogTitle()))])])])]),_vm._v(" "),_c('div',{staticClass:"container is-fluid bottom-header"},[(_vm.post)?_c('div',{staticClass:"breadcrumbs-parent"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/blog"}},[_vm._v("Blog")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":_vm.categorySlugLink()}},[_vm._v(_vm._s(_vm.capitalize(_vm.post.category.name)))])],1),_vm._v(" "),_c('li',{domProps:{"textContent":_vm._s(_vm.capitalize( _vm.blogTitle() ))}})])]):_vm._e(),_vm._v(" "),_c('app-mail-categories-sticky',{attrs:{"items":_vm.postsCategories}})],1),_vm._v(" "),_c('div',{staticClass:"container is-fluid"},[(!!_vm.post)?_c('section',{staticClass:"articles"},[_c('div',{staticClass:"card article shadowing"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content1 article-body",domProps:{"innerHTML":_vm._s(_vm.post.content)}})])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aW87":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bC5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_gmaps_GoogleMaps__ = __webpack_require__("lylM");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Hamburger menu
document.addEventListener('DOMContentLoaded', function () {

    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach(function ($el) {
            $el.addEventListener('click', function () {

                // Get the target from the "data-target" attribute
                var target = $el.dataset.target;
                var $target = document.getElementById(target);

                // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                $el.classList.toggle('is-active');
                $target.classList.toggle('is-active');
            });
        });
    }
});
// import Tooltip from 'vue-bulma-tooltip';

// import Swipper from '../elements/swipper/Swipper';



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-navbar',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_StringsMixin__["a" /* default */]],
    components: {
        // 'app-swipper': Swipper
    },

    // On route change, not on reload
    watch: {
        '$route': function $route(to, from) {
            console.log('wathc: ', to.name);
            this.$router.go(to.name);
        }
    },
    data: function data() {
        return {
            isActive: false,
            endpoint: __WEBPACK_IMPORTED_MODULE_2__env__["c" /* ApiHome */],
            // set to T if is should be on the home page
            showSwipper: true,
            image: ''
        };
    },


    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['swipping', 'menu', 'error', 'albumLocation']), {
        menuLeftItems: function menuLeftItems() {

            var menuLeftItems = [{ icon: 'fa-home', title: '', name: 'Domov', link: '/', swipper: true }, { icon: '', title: 'O nas', name: 'O nas', link: '/o-nas', swipper: false }, { icon: '', title: 'Kontakt', name: 'Kontakt', link: '/kontakt', swipper: false }, { icon: '', title: 'Blog', name: 'Blog', link: '/blog', swipper: false }];

            return menuLeftItems;
        }
    }),

    methods: {
        // Control on which pages swipper will be visible
        // (main pages: about, contact, ..)
        // not needed - we manage with route watch
        getMenu: function getMenu() {
            // console.log('items menu? ', this.albumLocation);
            this.$store.dispatch('fetchMenu', this.endpoint + 'menu');
        },
        clearGallery: function clearGallery() {
            var elem = document.getElementById('searchField');
            // console.log('elem: ', elem);
            if ((typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) !== undefined && elem !== null) {
                if (elem.hasOwnProperty('value')) {
                    elem.value = '';
                }
                this.$store.dispatch('fetchGallery', this.endpoint + 'gallery');
            }
        },

        // On click event for album dropdown
        sendItem: function sendItem(name) {
            var _this = this;

            // refactor - same functionality click event for specific album
            // on Album.vue
            // console.log('fetch album from navbar.vue');
            this.$store.dispatch('fetchAlbum', this.endpoint + 'album/' + name).then(function () {
                console.log('Started fetching item: ', _this.endpoint, _this.item);
                // console.log('fetching list of items: ');
                if (_this.error === null) {
                    _this.album = true;
                    console.log('Error is null: ', _this.loading);
                }
            });
        },


        // On click event for location dropdown
        sendItemLocation: function sendItemLocation(menuItem) {
            var _this2 = this;

            var element = document.getElementById('google-map');
            if (element !== null) {
                var opt = {
                    lat: menuItem.lat,
                    lng: menuItem.lng,
                    zoom: 5,
                    name: menuItem.name
                };
                console.log('navbar elem: ', element);
                var gmaps = new __WEBPACK_IMPORTED_MODULE_3__elements_gmaps_GoogleMaps__["a" /* default */](opt);
                gmaps.drawMap();
            }
            // refactor - same functionality click event for specific album
            // on Album.vue
            // console.log('fetch album from navbar.vue ', menuItem.slug);
            this.$store.dispatch('fetchLocation', this.endpoint + 'location/' + menuItem.slug).then(function () {
                // console.log('Started fetching location from navbar: ', this.endpoint, menuItem.name);
                // console.log('fetching list of items: ');
                if (_this2.error === null) {
                    // console.log('Error is null');
                }

                if (_this2.location !== null) {
                    // console.log('Location available: ', menuItem.lat, menuItem.lng, menuItem.name);
                    // Rewrite map if elem is available
                    var _element = document.getElementById('google-map');
                    if (_element !== null) {
                        var _opt = {
                            lat: menuItem.lat,
                            lng: menuItem.lng,
                            zoom: 5,
                            name: menuItem.name
                            // console.log('navbar elem: ', element);
                        };var _gmaps = new __WEBPACK_IMPORTED_MODULE_3__elements_gmaps_GoogleMaps__["a" /* default */](_opt);
                        _gmaps.drawMap();
                    }
                    // this.$store.dispatch('fetchPhotosLocation', this.endpoint);
                }
            });
        }
    },
    created: function created() {
        this.showSwipper = this.swipping;
        this.getMenu();
    }
});

/***/ }),

/***/ "bk6z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bpSX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags stycky-btn",on:{"click":function($event){_vm.toggle()},"blur":function($event){_vm.toggle()}}},[_c('span',{staticClass:"tag sticky-tag is-rounded-right is-size-3",class:{'is-large': _vm.isOpen, '': !_vm.isOpen }},[_c('i',{staticClass:"fa-lg",class:_vm.classObj}),_vm._v(" "),_c('span',{staticClass:"is-size-3 tag-text",class:{'is-hidden': !_vm.isOpen, 'animated fadeInLeft ': _vm.isOpen }},[_vm._v(" "+_vm._s(_vm.label))])]),_vm._v(" "),_c('ul',{class:{'is-hidden animated fadeOutLeft': !_vm.isOpen, 'animated fadeInLeft ': _vm.isOpen }},_vm._l((_vm.items),function(item){return _c('li',{key:item.id},[(_vm.type==='link')?_c('a',{attrs:{"href":item.url,"target":"_blank"}},[_vm._v("\n                "+_vm._s(item.name)+"\n            ")]):_c('a',{attrs:{"href":_vm.route + item.slug},nativeOn:{"click":function($event){_vm.getItems(item.slug)}}},[_vm._v("\n                "+_vm._s(item.name)+"\n            ")])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cSal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailCategoriesSticky_vue__ = __webpack_require__("8SjJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4d05f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailCategoriesSticky_vue__ = __webpack_require__("gNhW");
function injectStyle (ssrContext) {
  __webpack_require__("lVwV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailCategoriesSticky_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4d05f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailCategoriesSticky_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eGRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['item', 'link', 'defaultUrl', 'len'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],
    data: function data() {
        return {
            //
        };
    },


    computed: {
        getImage: function getImage() {

            if (this.link === '/albums/') {
                return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* AlbumsPhotoUrl */] + '300/' + this.item.image;
            }
        },
        albumUrl: function albumUrl() {
            return this.item.slug;
        },
        getLen: function getLen() {
            if (this.len === 2) {
                return 'is-one-half-desktop';
            }
            if (this.len === 3) {
                return 'is-one-third-desktop';
            }
            return 'is-one-quarter-desktop';
        }
    },

    methods: {
        sendItem: function sendItem(show) {
            // console.log('send item - just console: ', this.item);
            // this.$store.dispatch('sendItem', this.item);
        }
    },

    created: function created() {
        // console.log('album card created');
    }
});

/***/ }),

/***/ "ePne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlbumCard_vue__ = __webpack_require__("eGRc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d633a02e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlbumCard_vue__ = __webpack_require__("hs0m");
function injectStyle (ssrContext) {
  __webpack_require__("phsj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d633a02e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlbumCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d633a02e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlbumCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "egBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/*
Main menu
*/



/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * States
     */
    state: {
        menu: null
    },

    /**
     * Mutations
     */
    mutations: {
        setMenu: function setMenu(state, payload) {
            state.menu = payload;
        }
    },

    /**
     * Getters
     */
    getters: {
        menu: function menu(state) {
            return state.menu;
        }
    },

    /**
     * Actions
     */
    actions: {
        fetchMenu: function fetchMenu(_ref, payload) {
            var commit = _ref.commit;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                commit('setMenu', response.data);
            }).catch(function (error) {
                // commit(SET_ERROR, error.response);
                // commit(SET_LOADING, false);
                // console.log('STORE error fetching menu: ', this.getters.loading, this.getters.error);
            });
        }
    }
});

/***/ }),

/***/ "fZNE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"album-photo"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),(_vm.albumPhoto !== null && _vm.albumPhoto.hasOwnProperty('photo'))?_c('div',[_c('app-header',{attrs:{"info":_vm.albumPhoto.photo,"title":_vm.capitalize(_vm.title),"imagePath":_vm.imagePath,"isType":"photo","isClass":"is-fullheight1"}}),_vm._v(" "),_c('div',{staticClass:"columns nav-container mtb-80 rel"},[_c('div',{staticClass:"breadcrumbs-parent",staticStyle:{"display":"flex","top":"-50px","left":"20px"}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":'/' + _vm.albumPhoto.photo.album.slug}},[_vm._v(_vm._s(_vm.capitalize(_vm.albumPhoto.photo.album.name)))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":'/' + _vm.albumPhoto.photo.album.slug + '/' + _vm.albumPhoto.photo.location.slug}},[_vm._v(_vm._s(_vm.capitalize(_vm.albumPhoto.photo.location.name)))])],1),_vm._v(" "),_c('li',{domProps:{"textContent":_vm._s(_vm.capitalize(this.title))}})])]),_vm._v(" "),(_vm.albumPhoto.prev)?_c('div',{staticClass:"column"},[(_vm.albumPhoto.prev.hasOwnProperty('location'))?_c('p',{staticClass:"wide has-text-centered"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.albumPhoto.prev.location.name)))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"intro has-text-centered"},[_vm._v(_vm._s(_vm.albumPhoto.prev.date))]),_vm._v(" "),(_vm.albumPhoto.prev)?_c('a',{staticClass:"prev",attrs:{"href":_vm.albumPhoto.prev.slug}},[_c('img',{attrs:{"src":_vm.getPhoto(_vm.albumPhoto.prev),"alt":_vm.albumPhoto.prev.name}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column special-blockquote complex-line column"},[_c('span',{staticClass:"related weather"}),_vm._v(" "),_c('blockquote',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(_vm.albumPhoto.quote.quote))]),_vm._v(" "),_c('cite',[_vm._v(_vm._s(_vm.albumPhoto.quote.author))])])]),_vm._v(" "),(_vm.albumPhoto.next)?_c('div',{staticClass:"column has-text-right"},[(_vm.albumPhoto.next.location.hasOwnProperty('location'))?_c('p',{staticClass:"wide has-text-centered"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.albumPhoto.next.location.name)))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"intro has-text-centered"},[_vm._v(_vm._s(_vm.albumPhoto.next.date))]),_vm._v(" "),(_vm.albumPhoto.next)?_c('a',{staticClass:"next",attrs:{"href":_vm.albumPhoto.next.slug}},[_c('img',{attrs:{"src":_vm.getPhoto(_vm.albumPhoto.next),"alt":_vm.albumPhoto.next.name}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"links"},[_c('a',{attrs:{"href":_vm.slug}},[_vm._v("Vse slike")])]),_vm._v(" "),_c('app-google-map',{attrs:{"mapName":_vm.capitalize(this.title),"glat":_vm.albumPhoto.photo.location.lat,"glng":_vm.albumPhoto.photo.location.lng}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gDK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__ = __webpack_require__("Op8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de7c531_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__ = __webpack_require__("HXaB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de7c531_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gNhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mail-top",attrs:{"title":"Kontaktiraj nas"},on:{"click":function($event){_vm.openModal('modal-form')}}},[_vm._m(0)]),_vm._v(" "),(_vm.openedModal==='modal-form')?_c('app-modal',{attrs:{"id":'modal-form',"role":"dialog"},on:{"close":_vm.closeModal}},[_c('div',{staticClass:"mtb-20",attrs:{"slot":"header"},slot:"header"},[_c('h1',{staticClass:"title"},[_vm._v("Piši mi ")])]),_vm._v(" "),_c('div',{staticClass:"mtb-20",attrs:{"slot":"body"},slot:"body"},[_c('app-contact-form')],1)]):_vm._e(),_vm._v(" "),_c('app-stycky',{attrs:{"label":"Kategorije","items":_vm.items,"type":"tag","route":'/blog/'}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-envelope"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gRIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.albumId !== 'photo')?_c('h2',{staticClass:"sh-line is-size-2 has-text-centered"},[_c('span',[_vm._v("Slike")])]):_vm._e(),_vm._v(" "),_c('silentbox-group',{staticClass:"columns is-multiline is-gapless"},_vm._l((_vm.images),function(photo){return _c('div',{key:photo.image,staticClass:"column is-4 photos"},[_c('silentbox-item',{attrs:{"src":photo.path,"description":photo.caption,"autoplay":true}},[_c('img',{attrs:{"src":photo.src,"alt":photo.caption}}),_vm._v(" "),_c('div',{staticClass:"hide-overlay"},[(_vm.albumId==='photo-gallery')?_c('p',{staticClass:"if-photo"},[_c('router-link',{attrs:{"to":{ name: 'galleryPhotos', params: {  photo: photo.photoLink} }},nativeOn:{"click":function($event){_vm.clickPriority($event)}}},[_vm._v(_vm._s(photo.caption))])],1):_c('p',{staticClass:"else-photo"},[_c('router-link',{attrs:{"to":{name: 'AlbumPhoto', params: {album: photo.albumLink, location:photo.locationLink,  photo: photo.photoLink}}},nativeOn:{"click":function($event){_vm.clickPriority($event)}}},[_vm._v(_vm._s(photo.caption))])],1),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(photo.date))]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{name: 'AlbumLocation', params: {album: photo.albumLink, location: photo.locationLink}}},nativeOn:{"click":function($event){_vm.clickPriority($event)}}},[_vm._v(_vm._s(photo.location))])],1)])])],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "goMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ModalMixin__ = __webpack_require__("N/At");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-modal',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_ModalMixin__["a" /* default */]],
    data: function data() {
        return {
            //
        };
    },


    methods: {
        closeModal: function closeModal() {
            this.$emit('close');
        }
    }
});

/***/ }),

/***/ "h1hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-page"}},[_c('section',{staticClass:"hero is-default animated"},[_c('div',{staticClass:"hero-body"},[_c('app-swipper')],1)]),_vm._v(" "),(_vm.items.quote)?_c('app-action-call-general',{attrs:{"quote":_vm.items.quote}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"section mtb-40"},[_c('div',{staticClass:"columns is-multiline is-mobile"},_vm._l((_vm.items.albums),function(item){return _c('app-card',{key:item.id,attrs:{"item":item,"link":_vm.linkAlbums,"len":_vm.items.albums.length}})}))]),_vm._v(" "),_c('section',{staticClass:"section p0"},[(_vm.items.photos)?_c('div',{staticClass:"bg-light1 mtb-80"},[_c('app-sb',{attrs:{"photos":_vm.items.photos}})],1):_vm._e()]),_vm._v(" "),(_vm.items.testimonials && _vm.items.post)?_c('app-action-call-footer',{attrs:{"testimonials":_vm.items.testimonials,"post":_vm.items.post}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h34B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_overlay_vue__ = __webpack_require__("4iTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_96f61fe6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_overlay_vue__ = __webpack_require__("E9k1");
function injectStyle (ssrContext) {
  __webpack_require__("3l8e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_overlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_96f61fe6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hs0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"column is-full-mobile is-half-tablet",class:_vm.getLen},[_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-parent"},[_c('div',{staticClass:"tile is-child notification"},[_c('div',{staticClass:"box mt-20"},[(_vm.item.name)?_c('p',{staticClass:"is-size-4"},[_c('router-link',{attrs:{"to":_vm.item.slug},nativeOn:{"click":function($event){_vm.sendItem(_vm.item)}}},[_vm._v("\n                            "+_vm._s(_vm._f("capitalize")(_vm.item.name))+"\n                        ")])],1):_vm._e(),_vm._v(" "),(_vm.item.description)?_c('div',{staticClass:"content",domProps:{"textContent":_vm._s(_vm.truncate(_vm.item.description, 100))}}):_vm._e(),_vm._v(" "),(_vm.item.image)?_c('div',{staticClass:"parent-image"},[_c('figure',{staticClass:"image"},[_c('a',{attrs:{"href":_vm.albumUrl}},[_c('img',{attrs:{"src":_vm.getImage}})])])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i8Ld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("yzGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677b8cd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("QNom");
function injectStyle (ssrContext) {
  __webpack_require__("+HnR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677b8cd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iKIO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ixP2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__ = __webpack_require__("ZuEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d595edac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__ = __webpack_require__("K/6s");
function injectStyle (ssrContext) {
  __webpack_require__("n7/D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d595edac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d595edac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j7e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("UOlw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a19270ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("h1hj");
function injectStyle (ssrContext) {
  __webpack_require__("r4Bw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a19270ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a19270ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jIKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.albumId !== 'photo')?_c('h2',{staticClass:"sh-line is-size-2 has-text-centered"},[_c('span',[_vm._v("Slike")])]):_vm._e(),_vm._v(" "),_c('silentbox-group',{staticClass:"columns is-multiline is-gapless"},[_vm._l((_vm.images),function(photo){return _c('div',{key:photo.image,staticClass:"column is-4 photos"},[_c('silentbox-item',{attrs:{"src":photo.path,"description":photo.caption,"autoplay":true}},[_c('img',{attrs:{"src":photo.src,"alt":photo.caption,"width":"300","height":"225"}}),_vm._v(" "),_c('div',{staticClass:"hide-overlay"},[(_vm.albumId==='photo-gallery')?_c('p',{staticClass:"if-photo"},[_c('router-link',{attrs:{"to":{ name: 'galleryPhotos', params: {  photo: photo.photoLink} }},nativeOn:{"click":function($event){_vm.clickPriority($event)}}},[_vm._v(_vm._s(photo.caption))])],1):_c('p',{staticClass:"else-photo"},[_c('router-link',{attrs:{"to":{name: 'AlbumPhoto', params: {album: photo.albumLink, location:photo.locationLink,  photo: photo.photoLink}}},nativeOn:{"click":function($event){_vm.clickPriority($event)}}},[_vm._v(_vm._s(photo.caption))])],1),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(photo.date))]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{name: 'AlbumLocation', params: {album: photo.albumLink, location: photo.locationLink}}},nativeOn:{"click":function($event){_vm.clickPriority($event)}}},[_vm._v(_vm._s(photo.location))])],1)])])],1)}),_vm._v(" "),(_vm.albumId !== 'photo-gallery')?_c('h3',{staticClass:"links"},[_c('a',{attrs:{"href":_vm.slug}},[_vm._v("Vse slike")])]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jtOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_gmaps_GoogleMaps_vue__ = __webpack_require__("ixP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_pagination_PaginationPrevent_vue__ = __webpack_require__("sF+H");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['location', 'album'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        // console.log('album photo template: ', this.location);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'location/' + this.location + '/' + this.album,
            photoUrl: __WEBPACK_IMPORTED_MODULE_0__env__["e" /* LocationsPhotoUrl */],
            photoSize: '1960'
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-google-map': __WEBPACK_IMPORTED_MODULE_4__components_elements_gmaps_GoogleMaps_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_5__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_6__components_layout_BackButton_vue__["a" /* default */],
        'app-pagination': __WEBPACK_IMPORTED_MODULE_7__components_elements_pagination_PaginationPrevent_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['albumLocation', 'loading', 'error', 'title', 'paginate', 'pagination'])),

    methods: {
        /**
         * get paginated results - for page > 1
         */
        getResults: function getResults(page) {
            console.log('get paginated results: ', page);
            if (typeof page === 'undefined') {
                page = 2;
            }
            var data = {
                endpoint: this.endpoint + '?page=' + page,
                page: page,
                type: 'albumLocation'
            };

            this.$store.dispatch('getPaginatedItems', data);
        },
        fetchLocation: function fetchLocation() {
            this.$store.dispatch('fetchLocation', this.endpoint);
        }
    },

    created: function created() {
        this.fetchLocation();
        // console.log('location - Component created.', this.albumLocation, this.album, this.location)
    }
});

/***/ }),

/***/ "kXWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swipper_vue__ = __webpack_require__("ZMsq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c23fa248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Swipper_vue__ = __webpack_require__("swOi");
function injectStyle (ssrContext) {
  __webpack_require__("5Ao0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swipper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c23fa248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Swipper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "keRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-flex"},[_c('div',{staticClass:"is-inner-flex lucka"},[_c('div',{staticClass:"overflow"}),_vm._v(" "),_c('a',{attrs:{"href":"/lucka","data-title":"Lučka"}})]),_vm._v(" "),_c('div',{staticClass:"is-inner-flex figaro"},[_c('div',{staticClass:"overflow"}),_vm._v(" "),_c('a',{attrs:{"href":"/figaro","data-title":"Figaro"}})]),_vm._v(" "),_c('div',{staticClass:"is-inner-flex ola"},[_c('div',{staticClass:"overflow"}),_vm._v(" "),_c('a',{attrs:{"href":"/ola","data-title":"Ola"}})]),_vm._v(" "),_c('div',{staticClass:"is-inner-flex tesi"},[_c('div',{staticClass:"overflow"}),_vm._v(" "),_c('a',{attrs:{"href":"/tesi","data-title":"Tesi"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kgRB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ksSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_StringsMixin__ = __webpack_require__("2a/y");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-header',
    props: ['info', 'title', 'imagePath', 'isType', 'isClass', 'shortDesc'],
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        console.log('isType: ', this.isType, this.title);
        return {
            // list1: [],
        };
    },


    computed: {
        albumInfo: function albumInfo() {
            if (this.info) {

                var item = this.info;
                var thisDate = '';
                // console.log('albumInfo item: ' , this.info, ' if exists: info date: ' , this.info.date, ' or: ' ,this.info.from_date);
                // Date of photo taken
                if (this.isType === 'photo') {
                    if (this.info.date !== undefined || this.info.date !== null) {
                        thisDate = this.info.date;
                    }
                }
                if (this.isType === 'album') {
                    var thisBDate = '';
                    var thisDDate = '';
                    // Date of birth-death
                    if (this.info.from_date !== undefined || this.info.from_date !== null) {
                        thisBDate = this.info.dateFrom;
                    }

                    if (this.info.to_date !== undefined || this.info.to_date !== null) {
                        if (this.info.to_date !== '1970-01-01 00:00:00') {
                            thisDDate = this.info.dateTo;
                        }
                    }
                    if (thisDDate === '') {
                        thisDate = "<i class='fa fa-birthday-cake has-text-danger'></i> " + thisBDate;
                    } else {
                        thisDate = thisBDate + ' - ' + thisDDate;
                    }
                }

                return {
                    age: item.age,
                    image: this.albumImage(item.image),
                    description: item.description,
                    date: thisDate
                };
            }
        }
    },

    methods: {
        albumImage: function albumImage(image) {
            var elem = '<img src="" alt="photo" />';
            if (image === undefined || image === '') {
                return false;
            }
            var path = this.imagePath;

            return '<img src="' + path + '" alt="album" class="is-rounded" />';
        }
    }

});

/***/ }),

/***/ "kufV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress__ = __webpack_require__("GtG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_silentbox__ = __webpack_require__("mpLs");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;











// import * as filters from './filters';

window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */];
window.axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Lightbox for images
// https://github.com/silencesys/silentbox

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_silentbox__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_v_tooltip__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;

Object(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a);
var nprogress = new __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a({ parent: '.nprogress-container' });

var state = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state;

// var bus = new Vue();

var transitionName;

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (route, redirect, next) {
    if (route.meta.transitionName !== undefined) {
        _this.transitionName = route.meta.transitionName;
    }
    // console.log('router beforeEach: ' , route, ' redirect: ', redirect.path, 'next: ', next());
    // Set title dinamically
    if (route.meta.title !== undefined) {
        // console.log('Dynamic metatite: ', route.meta.title(route));
        document.title = route.meta.title(route);
    }

    next();
});

window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */];

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](_extends({
    el: '#app',
    data: {
        transitionName: transitionName
    },
    router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
    nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_6__App_vue__["a" /* default */]));

/***/ }),

/***/ "lVwV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lcSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lylM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GMaps = function () {
  /**
   * Create a new GMaps instance.
   *
   * @param {object} data
   */
  function GMaps(opt) {
    _classCallCheck(this, GMaps);

    this.lat = opt.lat;
    this.lng = opt.lng;
    this.latDefault = 46.0122;
    this.lngDefault = 13.565;
    this.zoom = 15;
    this.mapName = opt.name;
    this.mapElName = 'google-map';
    this.map = null;
  }

  _createClass(GMaps, [{
    key: 'getLat',
    value: function getLat() {
      // console.log('lat: ', this.lat);
      return parseFloat(this.lat) || this.latDefault;
    }
  }, {
    key: 'getLng',
    value: function getLng() {
      return parseFloat(this.lng) || this.lngDefault;
    }
  }, {
    key: 'getZoom',
    value: function getZoom() {
      return parseInt(this.zoom);
    }
  }, {
    key: 'drawMap',
    value: function drawMap() {

      var myLatLng = { lat: parseFloat(this.getLat()), lng: parseFloat(this.getLng()) };
      var element = document.getElementById(this.mapElName);
      if (element !== null || element !== undefined) {
        var options = {
          center: myLatLng,
          zoom: this.getZoom(),
          mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map']
          }
        };
        this.map = new google.maps.Map(element, options);

        this.addMarker(myLatLng);
        //Associate the styled map with the MapTypeId and set it to display.
        this.map.mapTypes.set('styled_map', this.styledMapType());
        this.map.setMapTypeId('styled_map');
      } else {
        console.log('elem is undefined !!!!!');
      }
      // console.log('GMaps lat lng ', this.lat, markerCoordinates[0], this.lat, this.lng);
    }
  }, {
    key: 'styledMapType',
    value: function styledMapType() {
      return new google.maps.StyledMapType([{ elementType: 'geometry', stylers: [{ color: '#ebe3cd' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1e6' }] }, {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#c9b2a6' }]
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#dcd2be' }]
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ae9e90' }]
      }, {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [{ color: '#fff' }]
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#fff' }]
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#93817c' }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [{ color: '#a5b076' }]
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#447530' }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#f5f1e6' }]
      }, {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ color: '#fdfcf8' }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#f8c967' }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#e9bc62' }]
      }, {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry',
        stylers: [{ color: '#e98d58' }]
      }, {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#db8555' }]
      }, {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#806b63' }]
      }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#fff' }]
      }, {
        featureType: 'transit.line',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8f7d77' }]
      }, {
        featureType: 'transit.line',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#ebe3cd' }]
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#fff' }]
      }, {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{ color: '#b9d3c2' }]
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#92998d' }]
      }], { name: 'Stiliziran' });
      // #fff = #dfd2ae
    }
  }, {
    key: 'markerIcon',
    value: function markerIcon() {
      // Star
      return {
        path: 'M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z',
        fillColor: 'lime',
        fillOpacity: 0.8,
        scale: 0.1,
        strokeColor: 'rgba(0,0,0,0.6)',
        strokeWeight: 3
      };
    }
  }, {
    key: 'addMarker',
    value: function addMarker(location) {
      var marker = new google.maps.Marker({
        position: location,
        map: this.map,
        icon: this.markerIcon(),
        title: this.mapName
      });
    }

    /* -------- end of class ---------- */

  }]);

  return GMaps;
}();

/* harmony default export */ __webpack_exports__["a"] = (GMaps);

/***/ }),

/***/ "mll2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolly__ = __webpack_require__("i8Yg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_MoreButton_vue__ = __webpack_require__("vZgc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_MailCategoriesSticky_vue__ = __webpack_require__("cSal");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['categorySlug', 'postSlug'],
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        // console.log('Post properties: ', this.categorySlug, this.postSlug)
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_2__env__["c" /* ApiHome */] + 'post/' + this.postSlug,
            endpointCategory: __WEBPACK_IMPORTED_MODULE_2__env__["c" /* ApiHome */] + '/' + this.categorySlug,
            query: '',
            errorClass: '',
            currentTag: null,
            selectedTags: [],
            tags: ['links', 'categories']
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_4__components_layout_HeaderBar_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_7__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_5__components_layout_BackButton_vue__["a" /* default */],
        'app-centered-button': __WEBPACK_IMPORTED_MODULE_6__components_layout_MoreButton_vue__["a" /* default */],
        'app-mail-categories-sticky': __WEBPACK_IMPORTED_MODULE_8__components_layout_MailCategoriesSticky_vue__["a" /* default */],
        Scrolly: __WEBPACK_IMPORTED_MODULE_1_vue_scrolly__["a" /* Scrolly */],
        ScrollyViewport: __WEBPACK_IMPORTED_MODULE_1_vue_scrolly__["c" /* ScrollyViewport */],
        ScrollyBar: __WEBPACK_IMPORTED_MODULE_1_vue_scrolly__["b" /* ScrollyBar */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['items', 'post', 'postsCategories', 'postsLinks', 'loading', 'error', 'title'])),

    methods: {
        fetchPost: function fetchPost() {
            this.$store.dispatch('fetchPost', this.endpoint);
        },
        postDate: function postDate(post) {
            if (post.updated === '') {
                return post.created;
            }
            return post.updated;
        },
        blogTitle: function blogTitle() {
            if (this.title !== '') {
                // console.log('title: ', this.title);
                return this.title;
            }
            // console.log('title empty');
            // return 'Blog o nemških ovčarjih, o Tesi, Oli, Lučki in Figaru, našemu mačku';
        },
        categorySlugLink: function categorySlugLink() {
            return '/blog/' + this.categorySlug;
        }
    },

    created: function created() {
        this.fetchPost();
        // console.log('Blog - Component mounted.')
    }
});

/***/ }),

/***/ "mqsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlay_vue__ = __webpack_require__("h34B");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxSingle',
    props: {
        // Media source, it could be an image or a youtube video.
        'src': {
            type: String,
            required: true
        },
        // Should be video autoplayed.
        'autoplay': {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        // Short description below image.
        'description': String
    },
    data: function data() {
        return {
            overlayVisibility: false,
            embedUrl: undefined,
            items: {
                total: 0,
                position: 0
            }
        };
    },

    components: {
        'silentbox-overlay': __WEBPACK_IMPORTED_MODULE_0__overlay_vue__["a" /* default */]
    },
    methods: {
        closeSilentBoxOverlay: function closeSilentBoxOverlay() {
            this.overlayVisibility = false;
        },
        openSilentBoxOverlay: function openSilentBoxOverlay() {
            if (this.src !== null) {
                this.embedUrl = this.src;
            }
            this.overlayVisibility = true;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$on('closeSilentboxOverlay', function () {
            _this.overlayVisibility = false;
        });

        window.addEventListener('keyup', function (event) {
            if (event.which == 27) {
                _this.overlayVisibility = false;
            }
        });
    }
});

/***/ }),

/***/ "mrMk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n7/D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsC1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-main',
    data: function data() {
        return {
            //
        };
    },


    computed: {
        transitionName: function transitionName() {
            if (this.$route.meta.hasOwnProperty('transitionName')) {
                return this.$route.meta.transitionName;
            }
            return 'fadeInLeft';
        }
    },

    components: {
        // 'app-transition': Transition,
    },

    created: function created() {
        // console.log('transitionName: ', this.$route.meta.transitionName);

    }
});

/***/ }),

/***/ "pMPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"is-size-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v("Prosimo izberite drug album, lokacijo, ali se vrnite na prejšnjo stran s klikom na spodnjo povezavo")]),_vm._v(" "),_c('div',{staticClass:"mb-40"},[_c('a',{staticClass:"link",on:{"click":_vm.goBack}},[_vm._m(0),_vm._v("\n            Nazaj\n        ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-arrow-left"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "phsj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qK3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Album_vue__ = __webpack_require__("552Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7225ad22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Album_vue__ = __webpack_require__("PN5l");
function injectStyle (ssrContext) {
  __webpack_require__("uz43")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Album_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7225ad22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Album_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qNu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-centered-button',
    props: ['link', 'text', 'classBtn']
});

/***/ }),

/***/ "qbeM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__("t0rc");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['label', 'items', 'route', 'type'],

    data: function data() {
        return {
            isOpen: false,
            endpoint: __WEBPACK_IMPORTED_MODULE_1__env__["c" /* ApiHome */] + 'posts',
            iclass: 'tag'
        };
    },


    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['posts', 'postsCategories', 'loading', 'error', 'title']), {
        classObj: function classObj() {
            if (this.type === 'link') {
                this.iclass = 'link';
            }
            return 'fa fa-' + this.iclass;
            // console.log('class obj ', this.type, this.iclass);
        }
    }),

    methods: {
        toggle: function toggle() {
            this.isOpen = !this.isOpen;
        },


        // Trigger load new data on button click
        getItems: function getItems(item) {
            // handle data and give it back to parent by interface
            this.$emit('getItem', item);
        }
    },

    created: function created() {
        // document.title = this.capitalize(this.photo);
        // console.log('Sticky Button - Component mounted.')
    }
});

/***/ }),

/***/ "r4Bw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sF+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginationPrevent_vue__ = __webpack_require__("zCFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138d0572_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginationPrevent_vue__ = __webpack_require__("0CA1");
function injectStyle (ssrContext) {
  __webpack_require__("kgRB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginationPrevent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138d0572_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginationPrevent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "swOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[_c('div',{staticClass:"parallax-bg",attrs:{"slot":"parallax-bg","data-swiper-parallax":"-23%"},slot:"parallax-bg"}),_vm._v(" "),_c('swiper-slide',{staticClass:"slide-1"},[_c('router-link',{attrs:{"to":{name: 'Album', params: {id: 'lucka'}}}},[_c('span',{staticClass:"title has-text-lime",attrs:{"data-swiper-parallax":"-100"}},[_vm._v("\n                    Lučka\n                ")]),_vm._v(" "),_c('span',{staticClass:"subtitle has-text-lime",attrs:{"data-swiper-parallax":"-200"}},[_vm._v("Naša lučka")]),_vm._v(" "),_c('span',{staticClass:"text",attrs:{"data-swiper-parallax":"-300"}},[_c('span',{staticClass:"swipper-green"},[_vm._v("To je moj prvi dan doma. Sem majhna, a videti že velika. Stara sem bila 3 leta in pol. Imam prijatelja, ki prihaja za mano iz prvega doma: Figaro")])])])],1),_vm._v(" "),_c('swiper-slide',{staticClass:"slide-2"},[_c('router-link',{attrs:{"to":{name: 'Album', params: {id: 'figaro'}}}},[_c('span',{staticClass:"title has-text-mediumspringgreen",attrs:{"data-swiper-parallax":"-100"}},[_vm._v("\n                    Figaro\n                ")]),_vm._v(" "),_c('span',{staticClass:"subtitle has-text-mediumspringgreen",attrs:{"data-swiper-parallax":"-200"}},[_vm._v("Navihan muc")]),_vm._v(" "),_c('span',{staticClass:"text",attrs:{"data-swiper-parallax":"-300"}},[_c('span',{staticClass:"swipper-green"},[_vm._v("Hej, jaz sem FIGARO! Nisem pes, sem pravi mačkon. Imam sestro Lučko, ki je ogromna in se je občasno bojim")])])])],1),_vm._v(" "),_c('swiper-slide',{staticClass:"slide-3"},[_c('router-link',{attrs:{"to":{name: 'Album', params: {id: 'ola'}}}},[_c('span',{staticClass:"title has-text-springgreen",attrs:{"data-swiper-parallax":"-100"}},[_vm._v("\n                    Ola\n                ")]),_vm._v(" "),_c('span',{staticClass:"text",attrs:{"data-swiper-parallax":"-300"}},[_c('span',{staticClass:"swipper-green"},[_vm._v("Mlada navihana, ljubeča, domiselna nemška ovčarka, ki smo jo izgubili v tragični nesreči. Vedno boš v naših srcih, Ola.")])]),_vm._v(" "),_c('span',{staticClass:"text",attrs:{"data-swiper-parallax":"-300"}},[_c('span',{staticClass:"swipper-green"},[_vm._v("\n                        2016-2017\n                    ")])])])],1),_vm._v(" "),_c('swiper-slide',{staticClass:"slide-4"},[_c('router-link',{attrs:{"to":{name: 'Album', params: {id: 'tesi'}}}},[_c('span',{staticClass:"title has-text-lime",attrs:{"data-swiper-parallax":"-100"}},[_vm._v("\n                     Tesi\n                ")]),_vm._v(" "),_c('span',{staticClass:"text",attrs:{"data-swiper-parallax":"-300"}},[_c('span',{staticClass:"swipper-green"},[_vm._v("Moja, naša dolgoletna prijateljica in spremljevalka, o kateri bi lahko pisala knjigo brez konca. Vedno boš med nami, Tesi.")])]),_vm._v(" "),_c('span',{staticClass:"text",attrs:{"data-swiper-parallax":"-300"}},[_c('span',{staticClass:"swipper-green"},[_vm._v("\n                        2004-2016\n                    ")])])])],1),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t0rc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return baseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PhotoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlbumsPhotoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LocationsPhotoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ApiHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ApiContactUs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GalleryAlbumLink; });
var url = void 0;
// console.log('NODE_ENV: ', process.env.NODE_ENV, 'location: ', location.origin);

if (location.origin === 'http://za-te.mypets-admin.local' || location.origin === 'http://localhost:8090') {
    url = "http://za-te.mypets-server.local";
} else {
    url = "http://mypets-laravel.za-te.net";
}
var baseUrl = url;

// ENDPOINTS
// url - without 'public'
var PhotoUrl = baseUrl + '/uploads/';
var AlbumsPhotoUrl = baseUrl + '/albums/';
var LocationsPhotoUrl = baseUrl + '/locations/';

// FRONTEND
var ApiHome = baseUrl + '/api/home/';
var ApiContactUs = baseUrl + '/api/home/contactSend';

// Frontend inner links
var GalleryAlbumLink = '/galerija/album/';

/***/ }),

/***/ "tnqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// for shared getters, mutations, actions ...


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        loading: false,
        error: null,
        success: null,
        showNotification: false,
        level: '',
        message: '',
        swipping: false,
        paginate: false,
        pagination: {},
        lng: '',
        lat: ''
    },

    mutations: (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], function (state, payload) {
        state.loading = payload;
    }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], function (state, payload) {
        state.error = payload;
    }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */], function (state) {
        state.error = null;
    }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_SUCCESS */], function (state, payload) {
        state.success = payload;
    }), _defineProperty(_mutations, 'setNotification', function setNotification(state, payload) {
        state.showNotification = payload.showNotification;
        state.message = payload.message;
        state.level = payload.level;
    }), _defineProperty(_mutations, 'clearNotification', function clearNotification(state) {
        state.showNotification = false;
        state.message = '';
        state.level = '';
    }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SWIPPER */], function (state, payload) {
        // console.log('set swipper store: ' , state, payload);
        state.swipping = payload;
    }), _defineProperty(_mutations, 'setPaginate', function setPaginate(state, payload) {
        // console.log('setPaginate', state, payload);
        state.paginate = true;
    }), _defineProperty(_mutations, 'setPagination', function setPagination(state, payload) {
        // console.log('setPagination: ', payload);
        // payload.delete(data);
        // state.pagination = payload;
        state.pagination = {
            current_page: payload.current_page,
            first_page_url: payload.first_page_url,
            last_page_url: payload.last_page_url,
            prev_page_url: payload.prev_page_url,
            next_page_url: payload.next_page_url,
            path: payload.path,
            from: payload.from,
            to: payload.to,
            total: payload.total,
            per_page: payload.per_page,
            last_page: payload.last_page
        };
    }), _defineProperty(_mutations, 'setPaginationCurrentPage', function setPaginationCurrentPage(state, payload) {
        state.pagination.current_page = payload;
    }), _defineProperty(_mutations, 'setLat', function setLat(state, payload) {
        // console.log('SET lag: ', payload);
        state.lat = payload;
    }), _defineProperty(_mutations, 'setLng', function setLng(state, payload) {
        // console.log('SET lng: ', payload);
        state.lng = payload;
    }), _mutations),

    getters: {
        showNotification: function showNotification(state) {
            return state.showNotification;
        },
        level: function level(state) {
            return state.level;
        },
        message: function message(state) {
            return state.message;
        },
        swipping: function swipping(state) {
            return state.swipping;
        },
        // error: state => state.error,
        error: function error(state) {
            // console.log('SHARED STORE - getters error: ', state);
            return state.error;
        },
        success: function success(state) {
            return state.success;
        },

        // loading: state => state.loading,
        loading: function loading(state) {
            // console.log('SHARED STORE - getters loading: ', state);
            return state.loading;
        },

        paginate: function paginate(state) {
            return state.paginate;
        },
        pagination: function pagination(state) {
            return state.pagination;
        },
        lat: function lat(state) {
            // console.log('getters lat: ', state.lat);
            return state.lat;
        },
        lng: function lng(state) {
            // console.log('getters lng: ', state.lng);
            return state.lng;
        }
    },

    actions: {
        setLat: function setLat(_ref, payload) {
            var commit = _ref.commit;

            commit('setLat', payload);
        },
        setLng: function setLng(_ref2, payload) {
            var commit = _ref2.commit;

            commit('setLng', payload);
        },
        setPaginationCurrentPage: function setPaginationCurrentPage(_ref3, payload) {
            var commit = _ref3.commit;

            commit('setPaginationCurrentPage', payload);
        },
        setLoading: function setLoading(_ref4, payload) {
            var commit = _ref4.commit;

            // console.log('SHARED STORE action setLoading: ', payload);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], payload);
        },
        setError: function setError(_ref5, payload) {
            var commit = _ref5.commit;

            // console.log('SHARED STORE action setError: ', payload);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], payload);
        },
        setSuccess: function setSuccess(_ref6, payload) {
            var commit = _ref6.commit;

            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_SUCCESS */], payload);
        },
        clearError: function clearError(_ref7, field) {
            var commit = _ref7.commit;

            // console.log('SHARED STORE Action clear error: ', field);
            if (field !== null || field !== undefined) {
                // delete this.error[field];

                // return;
            }
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);
        },
        setNotification: function setNotification(_ref8, payload) {
            var commit = _ref8.commit;

            commit('setNotification', payload);
        },
        clearNotification: function clearNotification(_ref9) {
            var commit = _ref9.commit;

            commit('clearNotification');
        },
        setSwipper: function setSwipper(_ref10, payload) {
            var commit = _ref10.commit;

            // console.log('set swipper action: ', payload, commit);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SWIPPER */], payload);
        }
    }
});

/***/ }),

/***/ "tuEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_MoreButton_vue__ = __webpack_require__("vZgc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_MailCategoriesSticky_vue__ = __webpack_require__("cSal");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['category'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'posts',
            endpointSearch: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'searchPosts',
            query: '',
            errorClass: ''
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__["a" /* default */],
        'app-centered-button': __WEBPACK_IMPORTED_MODULE_5__components_layout_MoreButton_vue__["a" /* default */],
        'app-mail-categories-sticky': __WEBPACK_IMPORTED_MODULE_7__components_layout_MailCategoriesSticky_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['postsCategory', 'posts', 'postsCategories', 'loading', 'error', 'title'])),

    methods: {
        fetchPosts: function fetchPosts(category) {
            if (typeof category === "undefined") {
                category = this.category;
            }
            this.$store.dispatch('fetchPosts', this.endpoint + '/' + category);
        },
        postDate: function postDate(post) {
            if (post.updated === '') {
                return post.created;
            }
            return post.updated;
        },


        // Triggered from button click to load new items
        getPosts: function getPosts(item) {
            // console.log('clicked - get new categories ', this.category, item);
            this.fetchPosts(item);
        }
    },

    created: function created() {
        this.fetchPosts();
        // console.log('BlogCategories - Component mounted.')
    }
});

/***/ }),

/***/ "uuel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-notification',
    props: ['level', 'message'],

    data: function data() {
        return {
            noteClass: 'note content ' + this.level
        };
    },


    computed: {
        classObj: function classObj() {
            if (this.level === 'error' || this.level === 'failure') {
                return this.noteClass + ' has-text-danger';
            }
            return this.noteClass + ' has-text-success';
        }
    },

    methods: {
        onClick: function onClick() {
            // console.log('emitted method sent TO parent');
            this.$emit('close');
        }
    },

    created: function created() {
        // console.log('notification created ');
    }
});

/***/ }),

/***/ "uz43":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOxz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_Notifications__ = __webpack_require__("3gNA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-contact-form',
    props: ['theme'],
    data: function data() {
        return {
            email: '',
            name: '',
            body: '',
            place: '',
            message: '',
            level: 'error',
            isShowing: false,
            isSent: false
        };
    },


    components: {
        'app-notification': __WEBPACK_IMPORTED_MODULE_1__layout_Notifications__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['error', 'loading', 'success']), {
        classObj: function classObj() {
            if (this.loading) {
                return ' is-loading';
            }
        },
        getResponse: function getResponse() {
            if (this.error) {
                // console.log('geterrors: ', this.error);
                this.message = 'Vnesi manjkajoče informacije';
                this.level = 'error';
                this.isShowing = true;
                this.name = this.email = this.body = '';
                return true;
            }

            if (this.success) {
                this.message = 'Hvala za poslano sporočilo';
                this.level = 'success';
                this.isShowing = true;
                this.isSent = true;
                this.name = this.email = this.body = this.place = '';
                return true;
            }

            if (this.message !== '') {
                this.name = this.email = this.body = '';
                return true;
            }
        },
        getSuccess: function getSuccess() {
            if (this.success) {
                this.message = 'Hvala za poslano sporočilo';
                this.level = 'success';
            }
        }
    }),

    methods: {
        validate: function validate() {
            if (this.email === '' || this.name === '' || this.body === '') {
                this.message = 'Vsa polja so obvezna';
                this.level = "error";
                this.isShowing = true;
                // console.log('false: ', this.message, this.email, this.name, this.body);
                return false;
            }
            this.isShowing = false;
            this.message = '';
            // console.log('true: ', this.message, this.email, this.name, this.body, this.isShowing);
            return true;
        },
        onSubmit: function onSubmit() {
            // console.log('submitted');
            if (this.validate()) {
                var contact = {
                    name: this.name,
                    email: this.email,
                    body: this.body
                };

                this.$store.dispatch('sendMail', contact);
            }
        },
        close: function close() {
            this.isShowing = false;
        }
    },

    mounted: function mounted() {
        // console.log('Contact Form - Component mounted.')
    }
});

/***/ }),

/***/ "vZgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreButton_vue__ = __webpack_require__("qNu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f735dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreButton_vue__ = __webpack_require__("5mWP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f735dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "viyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blog-page"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),_c('section',{staticClass:"hero is-info is-medium is-bold"},[(_vm.postsCategory)?_c('div',{staticClass:"hero-body",style:({ 'background-image': 'url(' + _vm.postsCategory.imagePath + ')' })},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.postsCategory.name))]),_vm._v(" "),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.postsCategory.description)}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"container is-fluid bottom-header"},[(_vm.postsCategory)?_c('div',{staticClass:"breadcrumbs-parent"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/blog"}},[_vm._v("Blog")])],1),_vm._v(" "),_c('li',{domProps:{"textContent":_vm._s(_vm.capitalize(_vm.postsCategory.name))}})])]):_vm._e(),_vm._v(" "),_c('app-mail-categories-sticky',{attrs:{"items":_vm.postsCategories}})],1),_vm._v(" "),_c('div',{staticClass:"container is-fluid"},[_c('section',{staticClass:"articles columns is-multiline"},_vm._l((_vm.posts),function(post){return _c('div',{key:post.title,staticClass:"column is-full-mobile is-half-tablet is-one-third-desktop shadowing"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-content has-text-centered"},[_c('p',{staticClass:"title article-title"},[_c('router-link',{attrs:{"to":'/blog/' + post.category.slug + '/' + post.slug}},[_vm._v("\n                                    "+_vm._s(_vm._f("capitalize")(post.title))+"\n                                ")])],1),_vm._v(" "),_c('div',{staticClass:"tags has-addons level-item"},[_c('span',{staticClass:"tag is-rounded is-dark"},[_vm._v("@"+_vm._s(post.user.first_name)+" "+_vm._s(post.user.last_name)+" ")]),_vm._v(" "),_c('span',{staticClass:"tag is-rounded"},[_vm._v("\n                                    "+_vm._s(post.created)+"\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"content article-body",domProps:{"innerHTML":_vm._s(post.content)}})]),_vm._v(" "),_c('div',{staticClass:"card-foot"},[_c('hr'),_vm._v(" "),_c('app-centered-button',{attrs:{"link":'/blog/' + post.category.slug + '/' + post.slug,"text":"Beri naprej"}})],1)])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vu9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("/vj7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c279272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("SSiF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c279272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wRHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero is-limegreen",class:_vm.isClass},[_c('div',{staticClass:"hero-body centered"},[(_vm.albumInfo.image)?_c('div',{staticClass:"hero-image",domProps:{"innerHTML":_vm._s(_vm.albumInfo.image)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"hero-foot"},[_c('h1',{staticClass:"embeded animated fadeInRight txt-center",domProps:{"textContent":_vm._s(_vm.capitalize(_vm.title))}}),_vm._v(" "),_c('div',{staticClass:"has-text-centered"},[_c('h2',{staticClass:"mtb-40",domProps:{"textContent":_vm._s(_vm.shortDesc)}}),_vm._v(" "),(_vm.isType === 'photo')?_c('p',{staticClass:"is-size-6"},[_c('span',{staticClass:"has-text-weight-bold is-size-5"},[_vm._v(" "+_vm._s(_vm.albumInfo.date))])]):_vm._e(),_vm._v(" "),(_vm.isType === 'photo')?_c('p',{staticClass:"is-size-4",domProps:{"innerHTML":_vm._s(_vm.albumInfo.age)}}):_vm._e(),_vm._v(" "),(_vm.isType === 'album')?_c('p',{staticClass:"is-size-4",domProps:{"innerHTML":_vm._s(_vm.albumInfo.date)}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wnLF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wqDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 *  Truncate at the given || default length
 *
 * 'lorem ipsum dolor' => 'lorem ipsum dol...'
 */

function truncate(value, length) {
  length = length || 15;
  if (!value || typeof value !== 'string') return '';
  if (value.length <= length) return value;
  return value.substring(0, length) + '...';
}

/* harmony default export */ __webpack_exports__["a"] = (truncate);

/***/ }),

/***/ "x03M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('div',{staticClass:"container is-fluid is-marginless app-content"},[_c('router-view',{staticClass:"animated",class:_vm.transitionName})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nprogress_src_NprogressContainer__ = __webpack_require__("DDB0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout___ = __webpack_require__("GPhf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_app_scss__ = __webpack_require__("kufV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_app_scss__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Navbar: __WEBPACK_IMPORTED_MODULE_2__components_layout___["c" /* Navbar */],
        AppMain: __WEBPACK_IMPORTED_MODULE_2__components_layout___["a" /* AppMain */],
        FooterBar: __WEBPACK_IMPORTED_MODULE_2__components_layout___["b" /* FooterBar */],
        NprogressContainer: __WEBPACK_IMPORTED_MODULE_1_vue_nprogress_src_NprogressContainer__["a" /* default */]
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),

/***/ "xQAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__("t0rc");
/*
only for home and menu
*/





/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * States
     */
    state: {
        items: []
    },

    /**
     * Mutations
     */
    mutations: {
        setItems: function setItems(state, payload) {
            // console.log('setItems', payload);
            state.items = payload;
        }
    },

    /**
     * Getters
     */
    getters: {
        // items: state => state.items,
        items: function items(state) {
            return state.items;
        }
    },

    /**
     * Actions
     */
    actions: {
        fetchItems: function fetchItems(_ref, payload) {
            var commit = _ref.commit;

            // console.log('store home: ', payload); // payload is the endpoint

            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                commit('setItems', response.data);
                var title = void 0;
                var description = void 0;
                var keywords = void 0;

                if (response.data.metas !== undefined) {
                    title = response.data.metas.meta_title;
                    description = response.data.metas.meta_description;
                    keywords = response.data.metas.meta_keywords;
                }
                if (response.data.settings !== undefined) {
                    commit('setLat', response.data.settings.lat);
                    commit('setLng', response.data.settings.lng);
                }

                // console.log('should metas: ', title, description, keywords);

                document.title = title;
                document.head.querySelector('meta[name=description]').content = description;
                document.head.querySelector('meta[name=keywords]').content = keywords;
                // console.log('home store items: ', this.getters.items, response.data);
            }).catch(function (error) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error);
                // console.log('Home STORE error fetching items: ', error);
            });
        },
        sendMail: function sendMail(_ref2, payload) {
            var commit = _ref2.commit;

            // console.log('SEND Mail ???: ', payload);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__env__["b" /* ApiContactUs */], payload).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // commit(SET_REGISTERED_USER, payload);
                // console.log('response: ', response.data);
                if (response.data.success === 0) {
                    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], response.data.message);
                } else {
                    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_SUCCESS */], response.data.success);
                }
            }).catch(function (error) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);

                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error.response);
                // console.log('error on send message: ', error);
            });
        }
    }

    //---------------- end export
});

/***/ }),

/***/ "xRK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weather"},[_c('a',{staticClass:"aw-widget-legal",attrs:{"href":"https://www.accuweather.com/en/si/kojsko/297375/weather-forecast/297375"}}),_c('div',{staticClass:"aw-widget-current",attrs:{"id":"awcc1527849160184","data-locationkey":"297375","data-unit":"c","data-language":_vm.language,"data-useip":"false","data-uid":"awcc1527849160184","data-targeturl":"http://za-te.net/vreme"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xUqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_gmaps_GoogleMaps_vue__ = __webpack_require__("ixP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['photo', 'photoDetails'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        // console.log('photo: ', this.photo, this.photoDetails, this);
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'photo/' + this.photo,
            photoSize: '1960',
            // photoSize: 'original',
            photoSmall: '300'
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__["a" /* default */],
        'app-google-map': __WEBPACK_IMPORTED_MODULE_5__components_elements_gmaps_GoogleMaps_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__["a" /* default */]
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['albumPhoto', 'loading', 'error', 'title']), {
        imagePath: function imagePath() {
            // console.log('photo: ', this.albumPhoto.photo.location);
            return this.albumPhoto.photo.imagePath;
        },
        slug: function slug() {
            return __WEBPACK_IMPORTED_MODULE_0__env__["d" /* GalleryAlbumLink */] + this.albumPhoto.photo.album.slug;
        }
    }),

    methods: {
        fetchPhoto: function fetchPhoto() {
            // console.log('FETCH photo (album-photo): ', this.photo, this.endpoint, this.album, this.$router);
            var album = '';
            if (typeof this.album !== 'undefined') {
                album = this.album;
            }
            var data = {
                endpoint: this.endpoint,
                type: 'photo',
                photo: this.photo
                // album: !!this.album
            };
            // console.log('PHOTO data: ', data);
            this.$store.dispatch('fetchPhoto', data);
        },
        getPhoto: function getPhoto(item) {
            return item.imagePath;
        }
    },

    created: function created() {
        this.fetchPhoto();
    }
});

/***/ }),

/***/ "xX90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_group_vue__ = __webpack_require__("ILy0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8a221008_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_group_vue__ = __webpack_require__("1b8p");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8a221008_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y9gd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"album-location"}},[(_vm.error)?_c('div',{staticClass:"container mtb-80"},[_c('app-back',{attrs:{"title":_vm.error}})],1):_vm._e(),_vm._v(" "),(_vm.albumLocation)?_c('div',[_c('app-header',{attrs:{"info":_vm.albumLocation.location,"title":_vm.capitalize(this.title),"imagePath":_vm.albumLocation.location.imagePath,"isType":"location"}}),_vm._v(" "),(_vm.albumLocation.photos)?_c('div',{staticClass:"rel"},[(_vm.albumLocation)?_c('div',{staticClass:"breadcrumbs-parent",staticStyle:{"display":"flex","top":"20px","left":"20px"}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":'/' + _vm.album}},[_vm._v(_vm._s(_vm.capitalize(_vm.album)))])],1),_vm._v(" "),_c('li',{domProps:{"textContent":_vm._s(_vm.capitalize(this.title))}})])]):_vm._e(),_vm._v(" "),_c('app-pagination',{attrs:{"pagination":_vm.pagination,"offset":4},nativeOn:{"click":function($event){_vm.getResults(_vm.pagination.current_page)}}}),_vm._v(" "),_c('app-sb',{attrs:{"photos":_vm.albumLocation.photos.data,"albumId":_vm.album}}),_vm._v(" "),_c('h3',{staticClass:"links"},[_c('router-link',{attrs:{"to":'/galerija/album/' + _vm.album}},[_vm._v("Vse slike ")])],1)],1):_vm._e(),_vm._v(" "),_c('app-google-map',{attrs:{"mapName":_vm.capitalize(this.title)}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yzGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("t0rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__ = __webpack_require__("2a/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__ = __webpack_require__("3gIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__ = __webpack_require__("1TnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_MoreButton_vue__ = __webpack_require__("vZgc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__ = __webpack_require__("Ju3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_FlexHeaderBar__ = __webpack_require__("FyGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_MailCategoriesSticky_vue__ = __webpack_require__("cSal");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import Pagination from '../../components/elements/pagination/Pagination.vue';


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['photo'],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringsMixin__["a" /* default */]],

    data: function data() {
        return {
            endpoint: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'posts',
            endpointSearch: __WEBPACK_IMPORTED_MODULE_0__env__["c" /* ApiHome */] + 'searchPosts',
            query: '',
            errorClass: ''
        };
    },


    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_3__components_layout_HeaderBar_vue__["a" /* default */],
        'app-sb': __WEBPACK_IMPORTED_MODULE_6__components_elements_silentbox_Silentbox_vue__["a" /* default */],
        'app-back': __WEBPACK_IMPORTED_MODULE_4__components_layout_BackButton_vue__["a" /* default */],
        'app-centered-button': __WEBPACK_IMPORTED_MODULE_5__components_layout_MoreButton_vue__["a" /* default */],
        'app-mail-categories-sticky': __WEBPACK_IMPORTED_MODULE_8__components_layout_MailCategoriesSticky_vue__["a" /* default */],
        'app-flex-header': __WEBPACK_IMPORTED_MODULE_7__components_layout_FlexHeaderBar__["a" /* default */]
        // 'app-pagination': Pagination,
    },

    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['posts', 'postsCategories', 'loading', 'error', 'title']
    // 'paginate',
    // 'pagination',
    ), {
        imagePath: function imagePath() {
            // console.log('image path: ', PhotoUrl);
            // return PhotoUrl + this.gallery.album_id + '/original/';
        }
    }),

    methods: {
        fetchPosts: function fetchPosts() {
            var data = {
                endpoint: this.endpoint
            };
            this.$store.dispatch('fetchPosts', this.endpoint);
        },
        postDate: function postDate(post) {
            if (post.updated === '') {
                return post.created;
            }
            return post.updated;
        }
    },

    created: function created() {
        this.fetchPosts();
        // console.log('Blog - Component mounted.')
    }
});

/***/ }),

/***/ "zCFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-pagination',
    props: {
        offset: {
            type: Number,
            default: 4
        }
    },
    data: function data() {
        return {
            currentPage: ''
        };
    },


    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['items', 'paginate', 'pagination', 'error']), {
        pagesNumber: function pagesNumber() {
            /*let mid;
            let range = [];*/
            // if only one page, hide pagination
            if (this.pagination.current_page === 1 && this.pagination.current_page === this.pagination.last_page) {
                return;
            }
            if (!this.pagination.to) {
                return [];
            }
            var from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            var to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            var pagesArray = [];
            for (from = 1; from <= to; from++) {
                pagesArray.push(from);
            }

            /*range.forEach(function (from) {
                if(mid) {
                    if(from - mid === 2) {
                        console.log('mid - from === 2');
                        pagesArray.push(mid+1);
                    } else if (from - mid !== 1){
                        console.log('from - mid not 1');
                        pagesArray.push('...');
                    }
                }
                pagesArray.push(from);
                mid = from;
            });*/
            return pagesArray;
        }
    }),

    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['setPaginationCurrentPage']), {
        onChange: function onChange(page) {
            this.$store.dispatch('setPaginationCurrentPage', page);
            this.currentPage = page;
        },
        getClass: function getClass(item) {
            return this.pagination.current_page !== item ? 'pagination-link' : 'pagination-link is-current';
        }
    }),
    mounted: function mounted() {
        // console.log('pagination prevent - Component mounted.');
    }
});

/***/ }),

/***/ "zSBs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
// for albums, locations, photos



/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * States
     */
    state: {
        albumMain: null,
        albumLocation: null,
        albumPhoto: null,
        gallery: null,
        endpoint: '',
        title: ''
    },

    /**
     * Mutations
     */
    mutations: {
        // having info about album + photos of the album
        setAlbumMain: function setAlbumMain(state, payload) {
            state.albumMain = payload;
        },
        setAlbumLocation: function setAlbumLocation(state, payload) {
            state.albumLocation = payload;
        },
        setAlbumPhoto: function setAlbumPhoto(state, payload) {
            state.albumPhoto = payload;
        },
        setGallery: function setGallery(state, payload) {
            state.gallery = payload;
        },
        setTitle: function setTitle(state, payload) {
            // console.log('SET lng: ', payload);
            state.title = payload;
        }
    },

    /**
     * Getters
     */
    getters: {
        albumMain: function albumMain(state) {
            return state.albumMain;
        },
        albumLocation: function albumLocation(state) {
            return state.albumLocation;
        },
        albumPhoto: function albumPhoto(state) {
            return state.albumPhoto;
        },
        gallery: function gallery(state) {
            return state.gallery;
        },
        title: function title(state) {
            return state.title;
        }
    },

    /**
     * Actions
     */
    actions: {
        fetchAlbum: function fetchAlbum(_ref, payload) {
            var commit = _ref.commit,
                getters = _ref.getters;

            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);
            // console.log('store fetchItem: ', payload);
            // type + id (ie: location, photo, album);
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // console.log('RESPONSE: ' , response.data.metas);
                if (response.data !== undefined) {
                    commit('setAlbumMain', response.data);
                    commit('setTitle', response.data.name);
                    // set meta description, meta keywords

                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                } else {}
                // console.log('STORE error fetching album: ', this.getters.loading, this.getters.error);

                // console.log('home store items: ', this.getters.items, response.data);
                // console.log('home store items: ',getters);
            }).catch(function (error) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error.response.data.errors.error);
                // console.log('STORE error fetching album: ', error.response.data.errors.error);
                // console.log('STORE error fetching album: ', this.getters.loading, this.getters.error);
            });
        },
        fetchPhoto: function fetchPhoto(_ref2, payload) {
            var commit = _ref2.commit,
                getters = _ref2.getters;

            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);
            // console.log('store fetchPhoto: ', payload.endpoint, payload);
            if (payload.type === 'photo') {
                // type + id (ie: location, photo, album);
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload.endpoint).then(function (response) {
                    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                    // console.log('RESPONSE: ' , response.data.photo);

                    if (response.data !== undefined) {
                        commit('setAlbumPhoto', response.data);
                        commit('setTitle', response.data.photo.album.name + ' ' + response.data.photo.location.title);
                        // set meta description, meta keywords
                        document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                        document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                        document.title = response.data.metas.meta_title;
                    }
                }).catch(function (error) {
                    // console.log('STORE error fetching photo: ', error);
                    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error.response.data.errors);
                    // commit(SET_ERROR, error.response.data.errors.error);
                });
            } else {
                // console.log('STORE fetch photo: ', data)
            }
        },
        fetchLocation: function fetchLocation(_ref3, payload) {
            var commit = _ref3.commit,
                getters = _ref3.getters;

            // console.log('time: ', Date.now());
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);
            // if reset, then will not work when you navigate from photo
            // to location on dropdown
            /*commit('setLat', '');
            commit('setLng', '');*/
            // console.log('store fetchLocation: ', payload);
            // type + id (ie: location, photo, album);
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // console.log('RESPONSE location: ' , response.data.metas);

                if (response.data !== undefined) {
                    commit('setAlbumLocation', response.data);
                    commit('setLat', response.data.location.lat);
                    commit('setLng', response.data.location.lng);
                    commit('setTitle', response.data.location.name);

                    // set meta description, meta keywords
                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;

                    commit('setPagination', response.data.photos);
                    commit('setPaginate', true);
                }
            }).catch(function (error) {
                console.log('STORE error fetching location: ', error.response.data.errors.error);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error.response.data.errors.error);
            });
        },
        fetchGallery: function fetchGallery(_ref4, payload) {
            var commit = _ref4.commit,
                getters = _ref4.getters;

            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);

            // console.log('store fetchGallery: ', payload, this.getters);
            // type + id (ie: location, photo, album);
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(payload.endpoint, payload)
            // axios.get(payload)
            .then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // console.log('RESPONSE: ' , response.data);

                if (response.data !== undefined) {
                    commit('setGallery', response.data);
                    commit('setPagination', response.data.photos);
                    commit('setPaginate', true);
                    if (typeof response.data.metas.albumName !== 'undefined') {
                        commit('setTitle', response.data.metas.albumName);
                    }
                    // console.log('getter pagination: ', this.getters.pagination);

                    // set meta description, meta keywords
                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                }
            }).catch(function (error) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                // console.log('STORE error fetching gallery: ',error);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error);
                // commit(SET_ERROR, error.response.data.message);
                // commit(SET_ERROR, error.response.data.errors.error);
            });
        },


        /*
        search gallery by keyword
         */
        fetchGalleryFilter: function fetchGalleryFilter(_ref5, payload) {
            var commit = _ref5.commit;

            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], true);
            commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CLEAR_ERROR */]);

            var data = {
                field: payload.field,
                keyword: payload.value
            };

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(payload.endpoint, data).then(function (response) {
                commit('setGallery', response.data);
                commit('setPagination', response.data.photos);

                commit('setPaginate', true);
                // no records ?
                if (response.data.error !== '') {
                    console.log('error: ', response.data.error);
                }

                document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                document.title = response.data.metas.meta_title;
                // console.log('STORE fetch gallery: ', response.data, this.getters.items);
            }).catch(function (error) {
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_LOADING */], false);
                commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error.response);
                console.log('error search: ', error);
            });
        },


        // payload: enpoint, page, type(gallery, locations)
        // getResultStore
        getPaginatedItems: function getPaginatedItems(_ref6, payload) {
            var commit = _ref6.commit;

            // console.log('get result store: ', payload);
            if (typeof payload.page === 'undefined') {
                page = 1;
            }
            if (payload.type === 'gallery') {
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(payload.endpoint, payload).then(function (response) {
                    // console.log('paginated items: ', response.data);
                    if (payload.type === 'gallery') {
                        commit('setGallery', response.data);
                        commit('setPagination', response.data.photos);
                    } else if (payload.type === 'albumLocation') {
                        commit('setAlbumLocation', response.data);
                        commit('setPagination', response.data.photos);
                    }

                    commit('setPaginate', true);
                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                }).catch(function (error) {
                    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error.response);
                });
            } else {
                // this.endpoint += '?results?page=' + page;
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(payload.endpoint).then(function (response) {
                    // console.log('paginated items: ', response.data);
                    if (payload.type === 'gallery') {
                        commit('setGallery', response.data);
                        commit('setPagination', response.data.photos);
                    } else if (payload.type === 'albumLocation') {
                        commit('setAlbumLocation', response.data);
                        commit('setPagination', response.data.photos);
                    }

                    commit('setPaginate', true);
                    document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                    document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                    document.title = response.data.metas.meta_title;
                }).catch(function (error) {
                    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_ERROR */], error.response);
                });
            }
        }
    }

});

/***/ }),

/***/ "zn69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrolly__ = __webpack_require__("i8Yg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_form_ContactForm__ = __webpack_require__("LSlJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_Modal_vue__ = __webpack_require__("PEfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ModalMixin__ = __webpack_require__("N/At");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-action-call-socials',
    props: [/*'testimonials',*/'post', 'zeroPadding'],
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ModalMixin__["a" /* default */]],
    components: {
        'app-modal': __WEBPACK_IMPORTED_MODULE_2__layout_Modal_vue__["a" /* default */],
        'app-contact-form': __WEBPACK_IMPORTED_MODULE_1__elements_form_ContactForm__["a" /* default */],
        Scrolly: __WEBPACK_IMPORTED_MODULE_0_vue_scrolly__["a" /* Scrolly */],
        ScrollyViewport: __WEBPACK_IMPORTED_MODULE_0_vue_scrolly__["c" /* ScrollyViewport */],
        ScrollyBar: __WEBPACK_IMPORTED_MODULE_0_vue_scrolly__["b" /* ScrollyBar */]
    },
    computed: {
        classObj: function classObj() {
            if (this.zeroPadding !== undefined) {
                return ' padding0';
            } else {
                return ' padding30';
            }
        }
    },
    data: function data() {
        return {
            //
        };
    }
});

/***/ })

},["lVK7"]);


// WEBPACK FOOTER //
// static/js/app.13362faa3f6606b3ae0b.js